import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, change, formValueSelector } from "redux-form";
import { Link } from "react-router";
import _ from "lodash";

import {
  FINANCIAL_DASHBOARD_LIST_LOAD,
  FINANCIAL_DASHBOARD_LIST_UNLOAD,
  FINANCIAL_DASHBOARD_CONTRACTS_EXPIRED_LOAD,
  FINANCIAL_DASHBOARD_CONTRACTS_EXPIRED_7_LOAD,
  FINANCIAL_DASHBOARD_CONTRACTS_EXPIRED_15_LOAD,
  FINANCIAL_DASHBOARD_CONTRACTS_EXPIRED_30_LOAD,
  FINANCIAL_DASHBOARD_COMPANIES_LOAD,
  UF_SYSTEM_LOAD,
  FINANCIAL_DASHBOARD_NOT_REGISTRED_LOAD,
  FINANCIAL_DASHBOARD_REGISTRED_ERROR_LOAD,
  FINANCIAL_DASHBOARD_REGISTRED_WITHOUT_IMAGE_LOAD,
  FINANCIAL_DASHBOARD_REGISTRED_LOAD,
  FINANCIAL_DASHBOARD_CLEAR_IMAGENS_VISAO,
  FINANCIAL_INVALID,
  FINANCIAL_LIST_FILTER,
} from "../../actions/Constants";
import api from "../../api/apiUtil";
import MaskDate from "../../components/Util/MaskDate";

import Title from "../../components/Layout/Title";

// ReactTable removed - using custom spreadsheet table
import { Bar } from "react-chartjs-2";
import { HorizontalBar } from "react-chartjs-2";
import { Line } from "react-chartjs-2";
import MaskDecimal from "../../components/Util/MaskDecimal";
import { ic_attach_money } from "react-icons-kit/md/ic_attach_money";
import SvgIcon from "react-icons-kit";
import { filePdf } from "react-icons-kit/icomoon/filePdf";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { fileExcelO } from "react-icons-kit/fa/fileExcelO";
import XLSX from "xlsx/dist/xlsx.mini.min";
import * as FileSaver from "file-saver";
import SelectField from "../../components/Fields/SelectField";
import MultiSelectField from "../../components/Fields/MultiSelectField";
import DropdownListField from "../../components/Fields/DropdownListField";
import { stack } from "react-icons-kit/icomoon/stack";
import { BeatLoader } from "react-spinners";
import { toastr } from "react-redux-toastr";
import MaskCNPJ from "../../components/Util/MaskCNPJ";
import OtherUtils from "../../components/Util/OtherUtils";
import feriados from "../../data/feriados.json";
import FinancialDashboardUfModal from "./FinancialDashboardUfModal";

const years = [
  { label: "Selecione", value: "" },
  { label: "2019", value: "2019" },
  { label: "2020", value: "2020" },
  { label: "2021", value: "2021" },
  { label: "2022", value: "2022" },
  { label: "2023", value: "2023" },
  { label: "2024", value: "2024" },
  { label: "2025", value: "2025" },
  { label: "2026", value: "2026" },
];

const trimestres = [
  { label: "Selecione", value: "" },
  { label: "Primeiro Timestre", value: "1" },
  { label: "Segundo Trimestre", value: "2" },
  { label: "Terceiro Trimestre", value: "3" },
  { label: "Quarto Trimestre", value: "4" },
];

const periodicidade = [
  { label: "Top 10", value: "1" },
  { label: "Top 20", value: "2" },
  { label: "Top 50", value: "3" },
  { label: "Todas com registro", value: "4" },
  { label: "Todas", value: "5" },
];

class FinancialDashboard extends React.Component {
  constructor() {
    super();
    this.state = {
      otherValuesSelected: false,
      selected: null,
      unit: null,
      top10: "all",
      credor: null,
      pesquisando: false,
      open: null,
      contractsNotRegistred: null,
      contractsRegistredError: null,
      contractsRegistredWithoutImage: null,
      contractsRegistred: null,
      contractsCancel: null,
      tipoPeriodo: "diario", // 'diario', 'mensal', 'semestral'
      ano: new Date().getFullYear(), // Current year as default
      mes: new Date().getMonth() + 1, // Current month as default
      tipoFinanceira: null,
      carteiras: [],
      exibirValores: true, // Default to showing values (R$), toggle to show quantities
      // New states for custom table
      sortColumn: -1,
      sortDirection: "none", // 'asc', 'desc', 'none'
      expandedRows: [], // Array of expanded financeira IDs
      subTableSort: {}, // { financeira.id: { column: index, direction: 'asc'|'desc'|'none' } }
      ufsModalOpen: false,
      ufsModalFinanceira: null,
      ufsModalData: null,
      ufsModalLoading: false,
    };
    this.myRef = null;
    this.tableContainerRef = React.createRef();
  }

  componentDidMount() {
    // Scroll to current day after initial render (if data is already loaded)
    if (this.props.listFilter && this.props.listFilter.colunas) {
      setTimeout(() => this.scrollToCurrentDay(), 500);
    }
  }

  componentWillUnmount() {
    // Component cleanup is handled by parent
  }

  componentDidUpdate(prevProps) {
    // Scroll to current day when data changes
    if (this.props.listFilter !== prevProps.listFilter && this.props.listFilter && this.props.listFilter.colunas) {
      setTimeout(() => this.scrollToCurrentDay(), 300);
    }
  }

  // Calculate total value for a financeira (sum of all columns)
  calculateFinanceiraTotal(financeira, useValor = true) {
    if (!financeira.dadosPorColuna || financeira.dadosPorColuna.length === 0) {
      return 0;
    }
    return financeira.dadosPorColuna.reduce((total, colData) => {
      if (typeof colData === "object" && colData !== null) {
        return total + (useValor ? colData.valorERC || 0 : colData.qtd || 0);
      }
      return total + (colData || 0);
    }, 0);
  }

  // Sort financeiras by total value (sum of all columns)
  sortFinanceirasByTotal(financeiras, useValor = true) {
    return financeiras.sort((a, b) => {
      const aTotal = this.calculateFinanceiraTotal(a, useValor);
      const bTotal = this.calculateFinanceiraTotal(b, useValor);
      return bTotal - aTotal; // Descending order
    });
  }

  handleOpenUfsModal(financeira, apenasEstaFinanceira) {
    this.setState({ ufsModalOpen: true, ufsModalFinanceira: financeira, ufsModalData: null, ufsModalLoading: true });
    const all = this.props.all || {};
    const params = {
      idFinanceira: financeira.id,
      ano: all.ano || this.state.ano,
      mes: all.mes || this.state.mes,
      tipoPeriodo: all.tipoVisualizacao || this.state.tipoPeriodo,
      uf: this.props.selectedUf && this.props.selectedUf.length === 2 ? this.props.selectedUf : null,
      apenasEstaFinanceira: !!apenasEstaFinanceira,
    };
    Promise.resolve(api.Management.dashboardFinanceiroUfPorFinanceira(params)).then(
      (res) => {
        this.setState({ ufsModalData: res, ufsModalLoading: false });
      },
      (err) => {
        console.log(err);
        this.setState({ ufsModalLoading: false });
        toastr.error("Erro", "Ocorreu um erro ao carregar a produção por UF.");
      },
    );
  }

  handleCloseUfsModal() {
    this.setState({ ufsModalOpen: false, ufsModalFinanceira: null, ufsModalData: null });
  }

  handleInputChange(value) {
    this.setState({ exibirValores: !this.state.exibirValores }, () => {
      // Force re-render to update the table with the new toggle state
      if (this.props.listFilter) {
        this.props.onListLoadFilter({ ...this.props.listFilter });
      }
    });
  }

  handleFilterChart(values) {
    if (values && values.mes && values.periodo) {
      toastr.info("Aviso", "A combinação de Mês e Periodicidade não é permitida. Por favor, selecione apenas um dos dois filtros.");
      return;
    }
    this.setState({ pesquisando: true });
    toastr.info("Aguarde", "Realizando consulta...", {
      timeOut: 0,
      component: () => {
        return <BeatLoader size={15} margin={2} color={"#58abc3"} loading={true} />;
      },
    });

    // Map form values to new API parameters
    let tipoPeriodo = "diario"; // Default to daily view
    if (values && values.periodo) {
      if (values.periodo === "1") {
        tipoPeriodo = "semestral";
      } else if (values.periodo === "2") {
        tipoPeriodo = "mensal";
      }
    }

    var obj = {
      ano: values && values.ano ? values.ano : this.state.ano,
      mes: values && values.mes ? parseInt(values.mes) : this.state.mes,
      tipoPeriodo: tipoPeriodo,
      tipoFinanceira: values && values.tipo ? values.tipo : this.state.tipoFinanceira,
      uf: values && values.uf ? values.uf : null,
      idParceiro: this.props.currentUser.idParceiro,
      idCarteira: this.props.currentUser.idCarteira || (values && values.idsCarteira && values.idsCarteira.length > 0 ? values.idsCarteira.map((c) => c.id) : null),
    };

    Promise.resolve(api.Management.dashboardFinancial2(obj)).then(
      async (res) => {
        // Sort financeiras by total value (sum of all columns)
        if (res.financeirasAgrupadas && res.financeirasAgrupadas.length > 0) {
          this.sortFinanceirasByTotal(res.financeirasAgrupadas, this.state.exibirValores);
        }

        this.props.onListLoad(res);
        this.props.onListLoadFilter(null);
        let resFilter = await this.filterListByParam({ ...this.props.all }, 20);
        this.props.dispatch(change("FinancialDashboardForm", "periodicidade", "2"));
        this.props.onListLoadFilter(resFilter);
        this.setState({ pesquisando: false });
        toastr.removeByType("info");
        if (
          !res ||
          (res.totalPorColuna &&
            res.totalPorColuna.every((total) => {
              // Check if total is object or simple value
              if (typeof total === "object" && total !== null) {
                return total.qtd === 0 && total.valorERC === 0;
              } else {
                return total === 0;
              }
            }))
        ) {
          toastr.info("Aviso", "Não foram encontrados resultados para essa pesquisa.");
        }
      },
      (err) => {
        console.log(err);
        this.setState({ pesquisando: false });
        toastr.removeByType("info");
        toastr.error("Erro", "Ocorreu um erro ao carregar os dados do dashboard.");
      },
    );
  }

  handleDefaultChart(values) {
    const { reset } = this.props;
    var uf = values.uf;

    // Default to current month daily view
    var obj = {
      ano: this.state.ano,
      mes: this.state.mes,
      tipoPeriodo: "diario", // Default to daily view
      tipoFinanceira: this.state.tipoFinanceira,
      uf: values && values.uf ? values.uf : null,
      idParceiro: this.props.currentUser.idParceiro,
    };

    Promise.resolve(api.Management.dashboardFinancial2(obj)).then(
      async (res) => {
        // Sort financeiras by total value (sum of all columns)
        if (res.financeirasAgrupadas && res.financeirasAgrupadas.length > 0) {
          this.sortFinanceirasByTotal(res.financeirasAgrupadas, this.state.exibirValores);
        }

        this.props.onListLoad(res);
        this.props.onListLoadFilter(null);
        let resFilter = await this.filterListByParam({ ...this.props.all }, 20);
        this.props.dispatch(change("FinancialDashboardForm", "periodicidade", "2"));
        this.props.onListLoadFilter(resFilter);
        if (this.props.anyTouched) reset();
        this.props.dispatch(change("FinancialDashboardForm", "uf", uf));
      },
      (err) => {
        console.log(err);
      },
    );
  }

  componentWillMount() {
    Promise.resolve(api.Carteira.list()).then((carteiras) => {
      this.setState({ carteiras: [{ id: null, nome: "" }, ...carteiras] });
    });

    // Load initial data with daily view for current month
    var obj = {
      ano: this.state.ano,
      mes: this.state.mes,
      tipoPeriodo: "diario", // Default to daily view
      tipoFinanceira: this.state.tipoFinanceira,
      uf: null,
      idParceiro: this.props.currentUser.idParceiro,
      idCarteira: this.props.currentUser.idCarteira || null,
    };

    Promise.resolve(api.Management.dashboardFinancial2(obj)).then(async (res) => {
      // Sort financeiras by total value (sum of all columns)
      if (res.financeirasAgrupadas && res.financeirasAgrupadas.length > 0) {
        this.sortFinanceirasByTotal(res.financeirasAgrupadas, this.state.exibirValores);
      }

      this.props.onListLoad(res);
      let resFilter = await this.filterListByParam({ ...this.props.all }, 20);
      this.props.dispatch(change("FinancialDashboardForm", "periodicidade", "2"));
      this.props.onListLoadFilter(resFilter);
      this.props.onCompaniesLoad([{ cnpj: 0, razaoSocial: "Todos" }, ...res.financeiras]);
    });

    this.handleContractImages({ cnpj: 0 });
    this.props.onListLoadFinancialInvalid(api.Financial.listFinancialInvalid());
    if (this.props.currentUser.tipo && this.props.currentUser.tipo.includes("P")) {
      Promise.resolve(api.Financial.recuperaUfsParceiro(this.props.currentUser.idParceiro)).then((all) => {
        this.props.onUfSystemLoad([{ sigla: "Todas" }, ...all.ufs]);
      });
    } else {
      Promise.resolve(api.Ufs.sigla_system()).then((all) => {
        var todas = {
          sigla: "Todas",
        };
        all.unshift(todas);
        this.props.onUfSystemLoad(all);
      });
    }
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  async filterListByParam(list, param) {
    let item = list;
    item.financeirasAgrupadas = item.financeirasAgrupadas.slice(0, param);

    // IMPORTANTE: Mantemos os totais originais da API (totalPorColuna)
    // para exibir os totais de TODAS as financeiras, não apenas do grupo filtrado

    // Keep the old properties for backward compatibility
    item.qtdTotalMes1 = item.totalPorColuna && item.totalPorColuna[0] ? item.totalPorColuna[0] : 0;
    item.qtdTotalMes2 = item.totalPorColuna && item.totalPorColuna[1] ? item.totalPorColuna[1] : 0;
    item.qtdTotalMes3 = 0; // Placeholder, will be calculated based on new structure if needed

    // For backward compatibility, set old properties if they exist
    if (item.financeirasAgrupadas && item.financeirasAgrupadas.length > 0) {
      // Calculate old totals from new data structure
      item.qtdTotalMes1 =
        this.calculateSum(item.financeirasAgrupadas, "qtdMes1") ||
        (item.financeirasAgrupadas.length > 0 && item.financeirasAgrupadas[0].dadosPorColuna && item.financeirasAgrupadas[0].dadosPorColuna[0]
          ? typeof item.financeirasAgrupadas[0].dadosPorColuna[0] === "object"
            ? item.financeirasAgrupadas[0].dadosPorColuna[0].qtd || 0
            : item.financeirasAgrupadas[0].dadosPorColuna[0] || 0
          : 0);
      item.qtdTotalMes2 =
        this.calculateSum(item.financeirasAgrupadas, "qtdMes2") ||
        (item.financeirasAgrupadas.length > 0 && item.financeirasAgrupadas[0].dadosPorColuna && item.financeirasAgrupadas[0].dadosPorColuna[1]
          ? typeof item.financeirasAgrupadas[0].dadosPorColuna[1] === "object"
            ? item.financeirasAgrupadas[0].dadosPorColuna[1].qtd || 0
            : item.financeirasAgrupadas[0].dadosPorColuna[1] || 0
          : 0);
      item.qtdTotalMes3 = this.calculateSum(item.financeirasAgrupadas, "qtdMes3");
      item.valorDetranTotalMes1 = this.calculateSum(item.financeirasAgrupadas, "valorDetranMes1");
      item.valorDetranTotalMes2 = this.calculateSum(item.financeirasAgrupadas, "valorDetranMes2");
      item.valorDetranTotalMes3 = this.calculateSum(item.financeirasAgrupadas, "valorDetranMes3");
      item.valorERCTotalMes1 = this.calculateSum(item.financeirasAgrupadas, "valorERCMes1");
      item.valorERCTotalMes2 = this.calculateSum(item.financeirasAgrupadas, "valorERCMes2");
      item.valorERCTotalMes3 = this.calculateSum(item.financeirasAgrupadas, "valorERCMes3");
    }

    return item;
  }

  calculateSum(array, property) {
    const total = array.reduce((accumulator, object) => {
      return accumulator + object[property];
    }, 0);
    return total;
  }

  // Method to get table data with totals row at the beginning and end
  getTableDataWithTotals() {
    if (!this.props.listFilter || !this.props.listFilter.financeirasAgrupadas) {
      return [];
    }

    // Create totals row for header
    const totalsRowHeader = {
      isTotalsRow: true,
      razaoSocial: "Total",
      nomeAgrupamento: "Total",
      correspondentes: [],
      dadosPorColuna: this.props.listFilter.totalPorColuna || [],
    };

    // Create totals row for footer
    const totalsRowFooter = {
      isTotalsRow: true,
      razaoSocial: "Total",
      nomeAgrupamento: "Total",
      correspondentes: [],
      dadosPorColuna: this.props.listFilter.totalPorColuna || [],
    };

    // Return totals row first, then the actual data, then totals row at the end
    return [totalsRowHeader, ...this.props.listFilter.financeirasAgrupadas, totalsRowFooter];
  }

  // Method to generate dynamic columns based on the data structure
  generateTableColumns() {
    // Check if using new data structure
    if (this.props.listFilter && this.props.listFilter.colunas && this.props.listFilter.colunas.length > 0) {
      // Create the main columns
      const columns = [
        {
          expander: true,
          Header: "",
          width: 35,
          headerClassName: "sticky-expander-col",
          className: "sticky-expander-col",
          Expander: ({ isExpanded, ...rest }) => {
            return <div className="div-expander">{rest.original.correspondentes.length >= 2 ? isExpanded ? <span> &#x2bc6;</span> : <span> &#x2bc8;</span> : null}</div>;
          },
          getProps: (state, rowInfo, column) => {
            if (!rowInfo || (rowInfo && rowInfo.original.correspondentes.length < 2)) {
              return {
                onClick: () => {},
              };
            }
            return {
              className: "show-pointer sticky-expander-col",
            };
          },
        },
        {
          Header: "Financeiras",
          accessor: "razaoSocial",
          className: "align-middle text-center sticky-financeiras-col",
          headerClassName: "font-extra-bold sticky-financeiras-col",
          width: 290,
          Cell: (row) => {
            if (row.original.isTotalsRow) {
              return <div style={{ textAlign: "left", fontWeight: "bold" }}>Total:</div>;
            }
            return (
              <div className="cursor-pointer" style={{ textAlign: "left" }}>
                {row.original.nomeAgrupamento ? row.original.nomeAgrupamento.toUpperCase() : row.original.razaoSocial}
              </div>
            );
          },
        },
      ];

      // Add dynamic columns based on the colunas array
      this.props.listFilter.colunas.forEach((col, index) => {
        // Add column for quantity (Qtd) or value (R$ Alias) based on toggle
        let columnWidth = this.state.exibirValores ? 120 : 80;

        // Increase width for semestral view columns
        if (col.tipo === "semestre") {
          columnWidth = this.state.exibirValores ? 300 : 240;
        }

        columns.push({
          Header: col.descricao,
          accessor: `dadosPorColuna[${index}]`,
          className: "align-middle text-center",
          headerClassName: "font-extra-bold",
          //width: columnWidth,
          sortMethod: (a, b) => {
            // Handle both object and simple value structures
            let aVal = a || 0;
            let bVal = b || 0;

            if (typeof a === "object" && a !== null) {
              aVal = this.state.exibirValores ? a.valorERC || 0 : a.qtd || 0;
            }

            if (typeof b === "object" && b !== null) {
              bVal = this.state.exibirValores ? b.valorERC || 0 : b.qtd || 0;
            }

            return aVal - bVal;
          },
          Cell: (row) => {
            const cellData = row.original.dadosPorColuna && row.original.dadosPorColuna[index];
            let displayValue;

            if (cellData && typeof cellData === "object") {
              // New structure with both quantity and value
              displayValue = this.state.exibirValores ? cellData.valorERC || 0 : cellData.qtd || 0;
            } else {
              // Old structure with simple value
              displayValue = cellData || 0;
            }

            // Check if this is the totals row
            const isTotalsRow = row.original.isTotalsRow;
            const fontWeight = isTotalsRow ? "bold" : "normal";

            if (this.state.exibirValores) {
              return (
                <div className={isTotalsRow ? "" : "cursor-pointer"} style={{ textAlign: "center", fontWeight }}>
                  {MaskDecimal.TO_BRL(displayValue)}
                </div>
              );
            } else {
              return (
                <div className={isTotalsRow ? "" : "cursor-pointer"} style={{ textAlign: "center", fontWeight }}>
                  {displayValue}
                </div>
              );
            }
          },
        });
      });

      return columns;
    } else {
      // Fallback to old structure for backward compatibility
      return [
        {
          expander: true,
          Header: "",
          width: 35,
          headerClassName: "sticky-expander-col",
          className: "sticky-expander-col",
          Expander: ({ isExpanded, ...rest }) => {
            return <div className="div-expander">{rest.original.correspondentes.length >= 2 ? isExpanded ? <span> &#x2bc6;</span> : <span> &#x2bc8;</span> : null}</div>;
          },
          getProps: (state, rowInfo, column) => {
            if (!rowInfo || (rowInfo && rowInfo.original.correspondentes.length < 2)) {
              return {
                onClick: () => {},
              };
            }
            return {
              className: "show-pointer sticky-expander-col",
            };
          },
        },
        {
          Header: "Financeiras",
          accessor: "razaoSocial",
          className: "align-middle text-center sticky-financeiras-col",
          headerClassName: "font-extra-bold sticky-financeiras-col",
          width: 290,
          Cell: (row) => (
            <div className="cursor-pointer" style={{ textAlign: "left" }}>
              {row.original.nomeAgrupamento ? row.original.nomeAgrupamento.toUpperCase() : row.original.razaoSocial}
            </div>
          ),
          Footer: (
            <span>
              <strong>Total:</strong>{" "}
            </span>
          ),
        },
        {
          Header: `${this.props.listFilter.mes1}`,
          columns: [
            {
              Header: "Qtd",
              accessor: "qtdMes1",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              width: this.state.otherValuesSelected ? 45 : undefined,
              sortMethod: (a, b) => a - b,
              Cell: (row) => <div className="cursor-pointer">{row.original.qtdMes1}</div>,
              Footer: (
                <span>
                  <strong>{this.props.listFilter.qtdTotalMes1}</strong>
                </span>
              ),
            },
            {
              Header: "R$ Alias",
              accessor: "valorERCMes1",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              show: this.state.otherValuesSelected,
              minWidth: 90,
              sortMethod: (a, b) => a - b,
              Cell: (row) => (
                <div className="cursor-pointer" style={{ textAlign: "right" }}>
                  {MaskDecimal.TO_BRL(row.original.valorERCMes1)}
                </div>
              ),
              Footer: (
                <span>
                  <strong>{MaskDecimal.TO_BRL(this.props.listFilter.valorERCTotalMes1)}</strong>
                </span>
              ),
            },
            {
              Header: "R$ Detran",
              accessor: "valorDetranMes1",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              show: this.state.otherValuesSelected,
              minWidth: 90,
              sortMethod: (a, b) => a - b,
              Cell: (row) => (
                <div className="cursor-pointer" style={{ textAlign: "right" }}>
                  {MaskDecimal.TO_BRL(row.original.valorDetranMes1)}
                </div>
              ),
              Footer: (
                <span>
                  <strong>{MaskDecimal.TO_BRL(this.props.listFilter.valorDetranTotalMes1)}</strong>
                </span>
              ),
            },
          ],
        },
        {
          Header: `${this.props.listFilter.mes2}`,
          columns: [
            {
              Header: "Qtd",
              accessor: "qtdMes2",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              width: this.state.otherValuesSelected ? 45 : undefined,
              sortMethod: (a, b) => a - b,
              Cell: (row) => <div className="cursor-pointer">{row.original.qtdMes2}</div>,
              Footer: (
                <span>
                  <strong>{this.props.listFilter.qtdTotalMes2}</strong>
                </span>
              ),
            },
            {
              Header: "R$ Alias",
              accessor: "valorERCMes2",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              show: this.state.otherValuesSelected,
              minWidth: 90,
              sortMethod: (a, b) => a - b,
              Cell: (row) => (
                <div className="cursor-pointer" style={{ textAlign: "right" }}>
                  {MaskDecimal.TO_BRL(row.original.valorERCMes2)}
                </div>
              ),
              Footer: (
                <span>
                  <strong>{MaskDecimal.TO_BRL(this.props.listFilter.valorERCTotalMes2)}</strong>
                </span>
              ),
            },
            {
              Header: "R$ Detran",
              accessor: "valorDetranMes2",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              show: this.state.otherValuesSelected,
              minWidth: 90,
              sortMethod: (a, b) => a - b,
              Cell: (row) => (
                <div className="cursor-pointer" style={{ textAlign: "right" }}>
                  {MaskDecimal.TO_BRL(row.original.valorDetranMes2)}
                </div>
              ),
              Footer: (
                <span>
                  <strong>{MaskDecimal.TO_BRL(this.props.listFilter.valorDetranTotalMes2)}</strong>
                </span>
              ),
            },
          ],
        },
        {
          Header: `${this.props.listFilter.mes3}`,
          columns: [
            {
              Header: "Qtd",
              accessor: "qtdMes3",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              width: this.state.otherValuesSelected ? 45 : undefined,
              sortMethod: (a, b) => a - b,
              Cell: (row) => <div className="cursor-pointer">{row.original.qtdMes3}</div>,
              Footer: (
                <span>
                  <strong>{this.props.listFilter.qtdTotalMes3}</strong>
                </span>
              ),
            },
            {
              Header: "R$ Alias",
              accessor: "valorERCMes3",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              show: this.state.otherValuesSelected,
              minWidth: 90,
              sortMethod: (a, b) => a - b,
              Cell: (row) => (
                <div className="cursor-pointer" style={{ textAlign: "right" }}>
                  {MaskDecimal.TO_BRL(row.original.valorERCMes3)}
                </div>
              ),
              Footer: (
                <span>
                  <strong>{MaskDecimal.TO_BRL(this.props.listFilter.valorERCTotalMes3)}</strong>
                </span>
              ),
            },
            {
              Header: "R$ Detran",
              accessor: "valorDetranMes3",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              show: this.state.otherValuesSelected,
              minWidth: 90,
              sortMethod: (a, b) => a - b,
              Cell: (row) => (
                <div className="cursor-pointer" style={{ textAlign: "right" }}>
                  {MaskDecimal.TO_BRL(row.original.valorDetranMes3)}
                </div>
              ),
              Footer: (
                <span>
                  <strong>{MaskDecimal.TO_BRL(this.props.listFilter.valorDetranTotalMes3)}</strong>
                </span>
              ),
            },
          ],
        },
      ];
    }
  }

  // Method to generate dynamic columns for sub-tables (correspondentes)
  generateSubTableColumns(parentRow) {
    // Check if using new data structure
    if (this.props.listFilter && this.props.listFilter.colunas && this.props.listFilter.colunas.length > 0) {
      // Create the main columns for correspondentes
      const columns = [
        {
          Header: "Correspondentes",
          accessor: "razaoSocial",
          className: "align-middle text-center sticky-correspondentes-col",
          headerClassName: "font-extra-bold sticky-correspondentes-col",
          footerClassName: "sticky-correspondentes-col",
          width: 335,
          Cell: (row) => <div className="cursor-pointer">{row.original.razaoSocial}</div>,
          Footer: () => <strong>Total</strong>,
        },
      ];

      // Add dynamic columns based on the colunas array
      this.props.listFilter.colunas.forEach((col, index) => {
        let columnWidth = this.state.exibirValores ? 120 : 80;

        // Increase width for semestral view columns
        if (col.tipo === "semestre") {
          columnWidth = this.state.exibirValores ? 300 : 240;
        }

        columns.push({
          Header: col.descricao,
          accessor: `dadosPorColuna[${index}]`,
          className: "align-middle text-center",
          headerClassName: "font-extra-bold",
          footerClassName: "sub-table-footer-cell",
          //width: columnWidth,
          sortMethod: (a, b) => {
            // Handle both object and simple value structures
            let aVal = a || 0;
            let bVal = b || 0;

            if (typeof a === "object" && a !== null) {
              aVal = this.state.exibirValores ? a.valorERC || 0 : a.qtd || 0;
            }

            if (typeof b === "object" && b !== null) {
              bVal = this.state.exibirValores ? b.valorERC || 0 : b.qtd || 0;
            }

            return aVal - bVal;
          },
          Cell: (row) => {
            const cellData = row.original.dadosPorColuna && row.original.dadosPorColuna[index];
            let displayValue;

            if (cellData && typeof cellData === "object") {
              // New structure with both quantity and value
              displayValue = this.state.exibirValores ? cellData.valorERC || 0 : cellData.qtd || 0;
            } else {
              // Old structure with simple value
              displayValue = cellData || 0;
            }

            if (this.state.exibirValores) {
              return (
                <div className="cursor-pointer" style={{ textAlign: "center" }}>
                  {MaskDecimal.TO_BRL(displayValue)}
                </div>
              );
            } else {
              return (
                <div className="cursor-pointer" style={{ textAlign: "center" }}>
                  {displayValue}
                </div>
              );
            }
          },
          Footer: () => {
            // Calculate totals from this specific financeira's correspondentes
            let totalQtd = 0;
            let totalValorERC = 0;

            if (parentRow && parentRow.correspondentes) {
              parentRow.correspondentes.forEach((corresp) => {
                const cellData = corresp.dadosPorColuna && corresp.dadosPorColuna[index];
                if (cellData && typeof cellData === "object") {
                  totalQtd += cellData.qtd || 0;
                  totalValorERC += cellData.valorERC || 0;
                } else {
                  totalQtd += cellData || 0;
                }
              });
            }

            const displayTotal = this.state.exibirValores ? totalValorERC : totalQtd;

            if (this.state.exibirValores) {
              return (
                <span style={{ display: "block", textAlign: "center" }}>
                  <strong>{MaskDecimal.TO_BRL(displayTotal)}</strong>
                </span>
              );
            } else {
              return (
                <span style={{ display: "block", textAlign: "center" }}>
                  <strong>{displayTotal}</strong>
                </span>
              );
            }
          },
        });
      });

      return columns;
    } else {
      // Fallback to old structure for backward compatibility
      return [
        {
          Header: "Correspondentes",
          accessor: "razaoSocial",
          className: "align-middle text-center",
          headerClassName: "font-extra-bold",
          width: 335,
          sortMethod: (a, b) => a - b,
          Cell: (row) => <div className="cursor-pointer">{row.original.razaoSocial}</div>,
          getProps: () => ({
            style: {
              position: "sticky",
              left: 0,
              background: "white",
              zIndex: 2,
            },
          }),
        },
        {
          Header: `${this.props.listFilter.mes1}`,
          columns: [
            {
              Header: "Qtd",
              accessor: "qtdMes1",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              width: this.state.exibirValores ? 40 : undefined,
              sortMethod: (a, b) => a - b,
              Cell: (row) => <div className="cursor-pointer">{row.original.qtdMes1}</div>,
            },
            {
              Header: "R$ Alias",
              accessor: "valorERCMes1",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              show: this.state.exibirValores,
              minWidth: 90,
              sortMethod: (a, b) => a - b,
              Cell: (row) => (
                <div className="cursor-pointer" style={{ textAlign: "right" }}>
                  {MaskDecimal.TO_BRL(row.original.valorERCMes1)}
                </div>
              ),
            },
            {
              Header: "R$ Detran",
              accessor: "valorDetranMes1",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              show: this.state.exibirValores,
              minWidth: 90,
              sortMethod: (a, b) => a - b,
              Cell: (row) => (
                <div className="cursor-pointer" style={{ textAlign: "right" }}>
                  {MaskDecimal.TO_BRL(row.original.valorDetranMes1)}
                </div>
              ),
            },
          ],
        },
        {
          Header: `${this.props.listFilter.mes2}`,
          columns: [
            {
              Header: "Qtd",
              accessor: "qtdMes2",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              width: this.state.exibirValores ? 40 : undefined,
              sortMethod: (a, b) => a - b,
              Cell: (row) => <div className="cursor-pointer">{row.original.qtdMes2}</div>,
            },
            {
              Header: "R$ Alias",
              accessor: "valorERCMes2",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              show: this.state.exibirValores,
              minWidth: 90,
              sortMethod: (a, b) => a - b,
              Cell: (row) => (
                <div className="cursor-pointer" style={{ textAlign: "right" }}>
                  {MaskDecimal.TO_BRL(row.original.valorERCMes2)}
                </div>
              ),
            },
            {
              Header: "R$ Detran",
              accessor: "valorDetranMes2",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              show: this.state.exibirValores,
              minWidth: 90,
              sortMethod: (a, b) => a - b,
              Cell: (row) => (
                <div className="cursor-pointer" style={{ textAlign: "right" }}>
                  {MaskDecimal.TO_BRL(row.original.valorDetranMes2)}
                </div>
              ),
            },
          ],
        },
        {
          Header: `${this.props.listFilter.mes3}`,
          columns: [
            {
              Header: "Qtd",
              accessor: "qtdMes3",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              width: this.state.exibirValores ? 40 : undefined,
              sortMethod: (a, b) => a - b,
              Cell: (row) => <div className="cursor-pointer">{row.original.qtdMes3}</div>,
            },
            {
              Header: "R$ Alias",
              accessor: "valorERCMes3",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              show: this.state.exibirValores,
              minWidth: 90,
              sortMethod: (a, b) => a - b,
              Cell: (row) => (
                <div className="cursor-pointer" style={{ textAlign: "right" }}>
                  {MaskDecimal.TO_BRL(row.original.valorERCMes3)}
                </div>
              ),
            },
            {
              Header: "R$ Detran",
              accessor: "valorDetranMes3",
              className: "align-middle text-center",
              headerClassName: "font-extra-bold",
              show: this.state.exibirValores,
              minWidth: 90,
              sortMethod: (a, b) => a - b,
              Cell: (row) => (
                <div className="cursor-pointer" style={{ textAlign: "right" }}>
                  {MaskDecimal.TO_BRL(row.original.valorDetranMes3)}
                </div>
              ),
            },
          ],
        },
      ];
    }
  }

  // ==========================================
  // NEW METHODS FOR CUSTOM SPREADSHEET TABLE
  // ==========================================

  // Retorna o dia da semana da coluna (0=domingo, 6=sabado) ou -1 se nao for coluna de dia
  getDayOfWeek(coluna) {
    if (!coluna || coluna.tipo !== "dia") return -1;
    const parts = coluna.descricao.split("/");
    if (parts.length !== 3) return -1;
    const [dia, mes, ano] = parts.map(Number);
    const date = new Date(2000 + ano, mes - 1, dia);
    return date.getDay();
  }

  // Verifica se a coluna é sabado (cor bege/amarelada)
  isWeekend(coluna) {
    return this.getDayOfWeek(coluna) === 6;
  }

  // Verifica se a coluna é domingo ou feriado nacional (cor rosa)
  isHoliday(coluna) {
    if (!coluna || coluna.tipo !== "dia") return false;
    if (this.getDayOfWeek(coluna) === 0) return true;
    return !!feriados[coluna.descricao];
  }

  // Retorna o nome do feriado/domingo para tooltip
  getHolidayName(coluna) {
    if (!coluna || coluna.tipo !== "dia") return "";
    if (feriados[coluna.descricao]) return feriados[coluna.descricao];
    if (this.getDayOfWeek(coluna) === 0) return "Domingo";
    return "";
  }

  // Retorna classe CSS de destaque da coluna
  getColumnHighlightClass(coluna) {
    if (this.isHoliday(coluna)) return "financial-spreadsheet-holiday";
    if (this.isWeekend(coluna)) return "financial-spreadsheet-weekend";
    return "";
  }

  // Format value based on exibirValores toggle
  formatValue(data) {
    if (!data) return this.state.exibirValores ? "R$ 0,00" : "0";
    if (typeof data === "object" && data !== null) {
      const value = this.state.exibirValores ? data.valorERC || 0 : data.qtd || 0;
      return this.state.exibirValores ? MaskDecimal.TO_BRL(value) : value;
    }
    return this.state.exibirValores ? MaskDecimal.TO_BRL(data || 0) : data || 0;
  }

  // Check if value is zero
  isZero(data) {
    if (!data) return true;
    if (typeof data === "object" && data !== null) {
      const value = this.state.exibirValores ? data.valorERC || 0 : data.qtd || 0;
      return value === 0;
    }
    return (data || 0) === 0;
  }

  // Get sort class for a column
  getSortClass(columnIndex) {
    if (this.state.sortColumn !== columnIndex) return "";
    if (this.state.sortDirection === "asc") return "financial-spreadsheet-sort-asc";
    if (this.state.sortDirection === "desc") return "financial-spreadsheet-sort-desc";
    return "";
  }

  // Sort data by column
  sortData(columnIndex) {
    let newDirection;
    if (this.state.sortColumn === columnIndex) {
      newDirection = this.state.sortDirection === "asc" ? "desc" : this.state.sortDirection === "desc" ? "none" : "asc";
    } else {
      newDirection = "asc";
    }
    this.setState({ sortColumn: columnIndex, sortDirection: newDirection });
  }

  // Get sorted data
  getSortedData() {
    if (!this.props.listFilter || !this.props.listFilter.financeirasAgrupadas) return [];
    if (this.state.sortDirection === "none" || this.state.sortColumn < 0) {
      return this.props.listFilter.financeirasAgrupadas;
    }

    return [...this.props.listFilter.financeirasAgrupadas].sort((a, b) => {
      const aData = a.dadosPorColuna && a.dadosPorColuna[this.state.sortColumn];
      const bData = b.dadosPorColuna && b.dadosPorColuna[this.state.sortColumn];

      let aVal = 0;
      let bVal = 0;

      if (aData && typeof aData === "object") {
        aVal = this.state.exibirValores ? aData.valorERC || 0 : aData.qtd || 0;
      } else {
        aVal = aData || 0;
      }

      if (bData && typeof bData === "object") {
        bVal = this.state.exibirValores ? bData.valorERC || 0 : bData.qtd || 0;
      } else {
        bVal = bData || 0;
      }

      return this.state.sortDirection === "asc" ? aVal - bVal : bVal - aVal;
    });
  }

  // Toggle row expansion
  toggleRow(financeira) {
    if (!financeira.correspondentes || financeira.correspondentes.length < 2) return;

    this.setState((prev) => ({
      expandedRows: prev.expandedRows.includes(financeira.id) ? prev.expandedRows.filter((id) => id !== financeira.id) : [...prev.expandedRows, financeira.id],
    }));
  }

  // Get subtable sort class
  getSubTableSortClass(finId, columnIndex) {
    const sortInfo = this.state.subTableSort[finId];
    if (!sortInfo || sortInfo.column !== columnIndex) return "";
    if (sortInfo.direction === "asc") return "financial-spreadsheet-sort-asc";
    if (sortInfo.direction === "desc") return "financial-spreadsheet-sort-desc";
    return "";
  }

  // Sort subtable data
  sortSubTable(finId, columnIndex) {
    const currentSort = this.state.subTableSort[finId] || { column: -1, direction: "none" };
    let newDirection;

    if (currentSort.column === columnIndex) {
      newDirection = currentSort.direction === "asc" ? "desc" : currentSort.direction === "desc" ? "none" : "asc";
    } else {
      newDirection = "asc";
    }

    this.setState((prev) => ({
      subTableSort: {
        ...prev.subTableSort,
        [finId]: { column: columnIndex, direction: newDirection },
      },
    }));
  }

  // Get sorted correspondentes for a financeira
  getSortedCorrespondentes(financeira) {
    if (!financeira.correspondentes) return [];
    const sortInfo = this.state.subTableSort[financeira.id];
    if (!sortInfo || sortInfo.direction === "none" || sortInfo.column < 0) {
      return financeira.correspondentes;
    }

    return [...financeira.correspondentes].sort((a, b) => {
      const aData = a.dadosPorColuna && a.dadosPorColuna[sortInfo.column];
      const bData = b.dadosPorColuna && b.dadosPorColuna[sortInfo.column];

      let aVal = 0;
      let bVal = 0;

      if (aData && typeof aData === "object") {
        aVal = this.state.exibirValores ? aData.valorERC || 0 : aData.qtd || 0;
      } else {
        aVal = aData || 0;
      }

      if (bData && typeof bData === "object") {
        bVal = this.state.exibirValores ? bData.valorERC || 0 : bData.qtd || 0;
      } else {
        bVal = bData || 0;
      }

      return sortInfo.direction === "asc" ? aVal - bVal : bVal - aVal;
    });
  }

  // Calculate subtable totals for a column
  calculateSubTableTotal(financeira, columnIndex) {
    if (!financeira.correspondentes) return 0;
    let total = 0;
    financeira.correspondentes.forEach((corresp) => {
      const data = corresp.dadosPorColuna && corresp.dadosPorColuna[columnIndex];
      if (data && typeof data === "object") {
        total += this.state.exibirValores ? data.valorERC || 0 : data.qtd || 0;
      } else {
        total += data || 0;
      }
    });
    return this.state.exibirValores ? MaskDecimal.TO_BRL(total) : total;
  }

  // Render subtable for correspondentes
  renderSubTable(financeira) {
    const colunas = this.props.listFilter.colunas || [];
    const correspondentes = this.getSortedCorrespondentes(financeira);

    return (
      <div className="financial-spreadsheet-subtable-container">
        <table className="financial-spreadsheet-subtable">
          <thead>
            <tr>
              <th>Correspondentes</th>
              {colunas.map((col, i) => (
                <th
                  key={i}
                  className={`${this.getColumnHighlightClass(col)} ${this.getSubTableSortClass(financeira.id, i)}`}
                  onClick={() => this.sortSubTable(financeira.id, i)}
                  title={this.getHolidayName(col)}
                >
                  {col.descricao}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {correspondentes.map((corresp, idx) => (
              <tr key={corresp.id || idx}>
                <td title={corresp.razaoSocial}>
                  <button
                    title="Ver produção por UF"
                    onClick={(e) => { e.stopPropagation(); this.handleOpenUfsModal(corresp, true); }}
                    style={{ background: "none", border: "none", cursor: "pointer", padding: "0 4px 0 0", color: "#555", verticalAlign: "middle" }}
                  >
                    <i className="fa fa-search" />
                  </button>
                  {corresp.razaoSocial}
                </td>
                {corresp.dadosPorColuna &&
                  corresp.dadosPorColuna.map((data, i) => (
                    <td key={i} className={`${this.getColumnHighlightClass(colunas[i])} ${this.isZero(data) ? "financial-spreadsheet-zero" : ""}`}>
                      {this.formatValue(data)}
                    </td>
                  ))}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="financial-spreadsheet-subtable-total">
              <td>Total</td>
              {colunas.map((col, i) => (
                <td key={i} className={this.getColumnHighlightClass(col)}>
                  {this.calculateSubTableTotal(financeira, i)}
                </td>
              ))}
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }

  // Scroll to current day
  scrollToCurrentDay() {
    const container = this.tableContainerRef.current;
    if (!container) return;

    // Verificar se temos dados de colunas
    if (!this.props.listFilter || !this.props.listFilter.colunas) return;

    const today = new Date();
    const todayDay = String(today.getDate()).padStart(2, "0");
    const todayMonth = String(today.getMonth() + 1).padStart(2, "0");
    const todayYear = String(today.getFullYear()).slice(-2);
    const todayFullStr = `${todayDay}/${todayMonth}/${todayYear}`;

    // Procurar a coluna do dia atual nos dados
    const colunas = this.props.listFilter.colunas;
    let targetIndex = -1;

    for (let i = 0; i < colunas.length; i++) {
      const col = colunas[i];
      if (col.tipo === "dia") {
        const descricao = col.descricao || "";
        // Tentar match exato primeiro (DD/MM/YY)
        if (descricao === todayFullStr) {
          targetIndex = i;
          break;
        }
        // Tentar match parcial (apenas o dia, ex: "07")
        if (descricao === todayDay) {
          targetIndex = i;
          break;
        }
        // Tentar extrair dia da descrição (pode ser "07/02" ou "07/02/26")
        const parts = descricao.split("/");
        if (parts.length >= 1 && parts[0] === todayDay) {
          // Verificar se o mês também bate (se disponível)
          if (parts.length >= 2) {
            if (parts[1] === todayMonth) {
              targetIndex = i;
              break;
            }
          } else {
            targetIndex = i;
            break;
          }
        }
      }
    }

    if (targetIndex >= 0) {
      // +1 para compensar a primeira coluna (sticky col com nome das financeiras)
      const headers = container.querySelectorAll("thead tr:first-child th");
      const targetColumn = headers[targetIndex + 1]; // +1 porque a primeira th é a coluna sticky

      if (targetColumn) {
        const fixedWidth = 320; // Width of sticky column
        const visibleWidth = container.clientWidth - fixedWidth;
        const targetLeft = targetColumn.offsetLeft;
        const targetWidth = targetColumn.offsetWidth;
        const scrollPos = targetLeft - fixedWidth - (visibleWidth - targetWidth) / 2;
        container.scrollLeft = Math.max(0, scrollPos);
      }
    }
  }

  // Render the new custom spreadsheet table
  renderSpreadsheetTable() {
    const colunas = this.props.listFilter.colunas || [];
    const totalPorColuna = this.props.listFilter.totalPorColuna || [];
    const sortedData = this.getSortedData();

    return (
      <div className="financial-spreadsheet-container" ref={this.tableContainerRef}>
        <table className="financial-spreadsheet-table">
          <thead>
            {/* Row 1: Column headers (dates) */}
            <tr>
              <th className="financial-spreadsheet-sticky-col">Financeiras</th>
              {colunas.map((col, i) => (
                <th key={i} className={`${this.getColumnHighlightClass(col)} ${this.getSortClass(i)}`} onClick={() => this.sortData(i)} title={this.getHolidayName(col)}>
                  {col.descricao}
                </th>
              ))}
            </tr>
            {/* Row 2: Totals */}
            <tr className="financial-spreadsheet-totals-header">
              <th className="financial-spreadsheet-sticky-col">Total:</th>
              {totalPorColuna.map((total, i) => (
                <th key={i} className={`${this.getColumnHighlightClass(colunas[i])} ${this.isZero(total) ? "financial-spreadsheet-zero" : ""}`}>
                  {this.formatValue(total)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedData.map((fin, rowIndex) => (
              <React.Fragment key={fin.id || rowIndex}>
                {/* Parent row (Financeira) */}
                <tr
                  className={`financial-spreadsheet-parent-row ${fin.correspondentes && fin.correspondentes.length >= 2 ? "financial-spreadsheet-has-children" : ""} ${this.state.expandedRows.includes(fin.id) ? "financial-spreadsheet-expanded" : ""}`}
                  onClick={() => this.toggleRow(fin)}
                >
                  <td className="financial-spreadsheet-sticky-col" title={fin.nomeAgrupamento || fin.razaoSocial}>
                    <button
                      title="Ver produção por UF"
                      onClick={(e) => { e.stopPropagation(); this.handleOpenUfsModal(fin); }}
                      style={{ background: "none", border: "none", cursor: "pointer", padding: "0 4px 0 0", color: "#555", verticalAlign: "middle" }}
                    >
                      <i className="fa fa-search" />
                    </button>
                    {fin.nomeAgrupamento || fin.razaoSocial}
                  </td>
                  {fin.dadosPorColuna &&
                    fin.dadosPorColuna.map((data, i) => (
                      <td key={i} className={`${this.getColumnHighlightClass(colunas[i])} ${this.isZero(data) ? "financial-spreadsheet-zero" : ""}`}>
                        {this.formatValue(data)}
                      </td>
                    ))}
                </tr>
                {/* Subtable row (Correspondentes) - shown when expanded */}
                {fin.correspondentes && fin.correspondentes.length >= 2 && (
                  <tr className={`financial-spreadsheet-subtable-row ${this.state.expandedRows.includes(fin.id) ? "financial-spreadsheet-visible" : ""}`}>
                    <td colSpan={colunas.length + 1}>{this.renderSubTable(fin)}</td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td className="financial-spreadsheet-sticky-col">Total:</td>
              {totalPorColuna.map((total, i) => (
                <td key={i} className={`${this.getColumnHighlightClass(colunas[i])} ${this.isZero(total) ? "financial-spreadsheet-zero" : ""}`}>
                  {this.formatValue(total)}
                </td>
              ))}
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }

  // ==========================================
  // END OF NEW METHODS
  // ==========================================

  async filtrarPeriodicidade(values) {
    let qtd = 0;
    let resFilter = null;
    if (values.periodicidade == "1") {
      qtd = 10;
    } else if (values.periodicidade == "2") {
      qtd = 20;
    } else if (values.periodicidade == "3") {
      qtd = 50;
    } else if (values.periodicidade == "4") {
      qtd = this.props.all.financeirasAgrupadas.length;
    } else {
      qtd = this.props.all.financeirasAgrupadas.length;
    }
    this.props.onListLoadFilter(null);
    if (values.periodicidade != "4") {
      resFilter = await this.filterListByParam({ ...this.props.all }, qtd);
      this.props.onListLoadFilter(resFilter);
    } else {
      resFilter = { ...this.props.all };
      // Filtra financeiras que possuem registros em qualquer coluna
      resFilter.financeirasAgrupadas = resFilter.financeirasAgrupadas.filter((item) => {
        // Verifica se há dados em qualquer coluna do item agrupado (inclui dados agregados dos correspondentes)
        if (item.dadosPorColuna && item.dadosPorColuna.length > 0) {
          const hasData = item.dadosPorColuna.some((colData) => {
            if (typeof colData === "object" && colData !== null) {
              return (colData.qtd > 0 || colData.valorERC > 0);
            } else {
              return (colData || 0) > 0;
            }
          });
          if (hasData) return true;
        }
        // Fallback: verifica dados diretamente nos correspondentes (caso a agregação não tenha propagado corretamente)
        if (item.correspondentes && item.correspondentes.length > 0) {
          const corHasData = item.correspondentes.some((cor) => {
            if (cor.dadosPorColuna && cor.dadosPorColuna.length > 0) {
              return cor.dadosPorColuna.some((colData) => {
                if (typeof colData === "object" && colData !== null) {
                  return (colData.qtd > 0 || colData.valorERC > 0);
                }
                return (colData || 0) > 0;
              });
            }
            return false;
          });
          if (corHasData) return true;
        }
        // Fallback para formato antigo da API
        return (item.qtdMes1 > 0 || item.qtdMes2 > 0 || item.qtdMes3 > 0);
      });
      resFilter = await this.filterListByParam(resFilter, resFilter.financeirasAgrupadas.length);
      this.props.onListLoadFilter(resFilter);
    }
  }

  // renderHorizontalBarData1(data) {
  //   return (
  //     <HorizontalBar
  //       data={data}
  //       height={30 * data.datasets[0].data.length + 45}
  //       options={{
  //         tooltips: {
  //           titleFontColor: "#E0E0E0",
  //           callbacks: {
  //             label: function (tooltipItem, data) {
  //               var label = data.datasets[tooltipItem.datasetIndex].label || "";

  //               if (label && label === "Valor em R$") {
  //                 label += ": " + MaskDecimal.TO_BRL(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]).substring(2);
  //               } else {
  //                 label += ": " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
  //               }
  //               return label;
  //             },
  //           },
  //         },
  //         legend: {
  //           display: false,
  //         },
  //         maintainAspectRatio: false,
  //       }}
  //     />
  //   );
  // }

  // renderHorizontalBarData2(data) {
  //   return (
  //     <HorizontalBar
  //       data={data}
  //       height={35 * data.datasets[0].data.length + 70}
  //       options={{
  //         tooltips: {
  //           titleFontColor: "#E0E0E0",
  //           callbacks: {
  //             label: function (tooltipItem, data) {
  //               var label = data.datasets[tooltipItem.datasetIndex].label || "";

  //               if (label && label.includes("Valor de")) {
  //                 label += ": " + MaskDecimal.TO_BRL(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]).substring(2);
  //               } else {
  //                 label += ": " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
  //               }
  //               return label;
  //             },
  //           },
  //         },
  //         maintainAspectRatio: false,
  //       }}
  //     />
  //   );
  // }

  // handleChangeTop10(type) {
  //   window.scrollTo(0, this.myRef.offsetTop + 50);
  //   this.setState({ top10: type });
  // }

  // handleChangeTopFake10(type) {
  //   this.setState({ top10: type });
  // }

  exportToCSV = () => {
    // Use the currently displayed data (filtered list) instead of all data
    const currentData = this.props.listFilter || this.props.all;

    // Check if using new data structure with colunas and dadosPorColuna
    if (currentData.colunas && currentData.colunas.length > 0) {
      // New structure - dynamic columns with merged headers (like original format)
      // For the non-grouped view, if financeira has correspondentes show only correspondentes, otherwise show financeira
      let financeirasToUse = [];

      // Process financeirasAgrupadas to follow the rule: if has correspondentes show only correspondentes, otherwise show financeira
      if (currentData.financeirasAgrupadas) {
        currentData.financeirasAgrupadas.forEach((fin) => {
          if (fin.correspondentes && fin.correspondentes.length > 0) {
            // If financeira has correspondentes, add only the correspondentes
            fin.correspondentes.forEach((corr) => {
              financeirasToUse.push({ ...corr }); // Clone to avoid modifying state
            });
          } else {
            // If financeira doesn't have correspondentes, add the financeira itself
            financeirasToUse.push({ ...fin }); // Clone to avoid modifying state
          }
        });
      } else if (currentData.financeiras) {
        // Fallback to old structure
        financeirasToUse = currentData.financeiras.map((fin) => ({ ...fin })); // Clone to avoid modifying state
      }

      // Create heading with merged month headers spanning Qtd and R$ columns
      var Heading = [
        ["", ...currentData.colunas.flatMap((col) => [col.descricao, ""])], // Top row: month names
        ["Financeiras", ...currentData.colunas.flatMap((col) => ["Qtd", "R$"])], // Bottom row: Qtd and R$
      ];
      var Data = [];

      // Add data rows with both quantity and value
      financeirasToUse.forEach((fin, index) => {
        const row = {
          razaoSocial: fin.razaoSocial,
        };

        // Add columns based on dadosPorColuna with both quantity and value
        fin.dadosPorColuna &&
          fin.dadosPorColuna.forEach((colData, colIndex) => {
            if (typeof colData === "object" && colData !== null) {
              // Add both quantity and value for each column
              row[`qtdCol${colIndex}`] = colData.qtd || 0;
              row[`valCol${colIndex}`] = colData.valorERC || 0;
            } else {
              // Old structure value - fallback
              row[`qtdCol${colIndex}`] = colData || 0;
              row[`valCol${colIndex}`] = 0; // No value in old structure
            }
          });

        Data.push(row);
      });

      // Add totals row with both quantity and value
      if (currentData.totalPorColuna) {
        const totalRow = { razaoSocial: "Total" };
        currentData.totalPorColuna.forEach((total, index) => {
          if (typeof total === "object" && total !== null) {
            // Add both quantity and value for totals
            totalRow[`qtdCol${index}`] = total.qtd || 0;
            totalRow[`valCol${index}`] = total.valorERC || 0;
          } else {
            // Old structure - fallback
            totalRow[`qtdCol${index}`] = total || 0;
            totalRow[`valCol${index}`] = 0;
          }
        });
        Data.push(totalRow);
      }

      var ws = XLSX.utils.aoa_to_sheet(Heading);
      // Create header array with both quantity and value columns
      const headerArray = ["razaoSocial", ...currentData.colunas.flatMap((col, idx) => [`qtdCol${idx}`, `valCol${idx}`])];
      XLSX.utils.sheet_add_json(ws, Data, {
        header: headerArray,
        skipHeader: true,
        origin: "A3", // Start from row 3 to accommodate the merged headers
      });

      // Create merge ranges for the month headers
      const merge = [];
      for (let i = 0; i < currentData.colunas.length; i++) {
        merge.push({ s: { r: 0, c: 1 + i * 2 }, e: { r: 0, c: 2 + i * 2 } }); // Merge month header across Qtd and R$
      }
      ws["!merges"] = merge;
    } else {
      // Old structure - fixed columns with both quantity and value
      var Heading = [
        ["", currentData.mes1.toUpperCase(), "", "", currentData.mes2.toUpperCase(), "", "", currentData.mes3.toUpperCase()],
        ["Financeiras", "Qtd", "R$ Alias", "R$ Detran", "Qtd", "R$ Alias", "R$ Detran", "Qtd", "R$ Alias", "R$ Detran"],
      ];
      var Data = [];

      // Process financeirasAgrupadas to follow the rule: if has correspondentes show only correspondentes, otherwise show financeira
      if (currentData.financeirasAgrupadas) {
        currentData.financeirasAgrupadas.forEach((fin) => {
          if (fin.correspondentes && fin.correspondentes.length > 0) {
            // If financeira has correspondentes, add only the correspondentes
            fin.correspondentes.forEach((corr) => {
              Data.push({
                razaoSocial: corr.razaoSocial,
                qtd1: corr.qtdMes1,
                rsAlias1: corr.valorERCMes1,
                rsDetran1: corr.valorDetranMes1,
                qtd2: corr.qtdMes2,
                rsAlias2: corr.valorERCMes2,
                rsDetran2: corr.valorDetranMes2,
                qtd3: corr.qtdMes3,
                rsAlias3: corr.valorERCMes3,
                rsDetran3: corr.valorDetranMes3,
              });
            });
          } else {
            // If financeira doesn't have correspondentes, add the financeira itself
            Data.push({
              razaoSocial: fin.razaoSocial,
              qtd1: fin.qtdMes1,
              rsAlias1: fin.valorERCMes1,
              rsDetran1: fin.valorDetranMes1,
              qtd2: fin.qtdMes2,
              rsAlias2: fin.valorERCMes2,
              rsDetran2: fin.valorDetranMes2,
              qtd3: fin.qtdMes3,
              rsAlias3: fin.valorERCMes3,
              rsDetran3: fin.valorDetranMes3,
            });
          }
        });
      } else if (currentData.financeiras) {
        // Fallback to old structure
        currentData.financeiras.forEach((fin, index) => {
          Data.push({
            razaoSocial: fin.razaoSocial,
            qtd1: fin.qtdMes1,
            rsAlias1: fin.valorERCMes1,
            rsDetran1: fin.valorDetranMes1,
            qtd2: fin.qtdMes2,
            rsAlias2: fin.valorERCMes2,
            rsDetran2: fin.valorDetranMes2,
            qtd3: fin.qtdMes3,
            rsAlias3: fin.valorERCMes3,
            rsDetran3: fin.valorDetranMes3,
          });
        });
      }

      Data.push(
        {
          razaoSocial: "",
          qtd1: "",
          rsAlias1: "",
          rsDetran1: "",
          qtd2: "",
          rsAlias2: "",
          rsDetran2: "",
          qtd3: "",
          rsAlias3: "",
          rsDetran3: "",
        },
        {
          razaoSocial: "Total",
          qtd1: currentData.qtdTotalMes1,
          rsAlias1: currentData.valorERCTotalMes1,
          rsDetran1: currentData.valorDetranTotalMes1,
          qtd2: currentData.qtdTotalMes2,
          rsAlias2: currentData.valorERCTotalMes2,
          rsDetran2: currentData.valorDetranTotalMes2,
          qtd3: currentData.qtdTotalMes3,
          rsAlias3: currentData.valorERCTotalMes3,
          rsDetran3: currentData.valorDetranTotalMes3,
        },
      );

      var ws = XLSX.utils.aoa_to_sheet(Heading);
      const merge = [
        { s: { r: 0, c: 1 }, e: { r: 0, c: 3 } },
        { s: { r: 0, c: 4 }, e: { r: 0, c: 6 } },
        { s: { r: 0, c: 7 }, e: { r: 0, c: 9 } },
      ];
      ws["!merges"] = merge;
      XLSX.utils.sheet_add_json(ws, Data, {
        header: ["razaoSocial", "qtd1", "rsAlias1", "rsDetran1", "qtd2", "rsAlias2", "rsDetran2", "qtd3", "rsAlias3", "rsDetran3"],
        skipHeader: true,
        origin: "A3",
      });
    }

    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Resultado");
    var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "DashboardFinanceiras-Tabela.xlsx");
  };

  exportToCSVGroup = () => {
    // Use the currently displayed data (filtered list) instead of all data
    const currentData = this.props.listFilter || this.props.all;

    // Check if using new data structure with colunas and dadosPorColuna
    if (currentData.colunas && currentData.colunas.length > 0) {
      // New structure - dynamic columns with merged headers (like original format)
      // For the grouped view, we should use financeirasAgrupadas
      let financeirasToUse = currentData.financeirasAgrupadas || currentData.financeiras || [];

      // Create heading with merged month headers spanning Qtd and R$ columns
      var Heading = [
        ["", ...currentData.colunas.flatMap((col) => [col.descricao, ""])], // Top row: month names
        ["Financeiras", ...currentData.colunas.flatMap((col) => ["Qtd", "R$"])], // Bottom row: Qtd and R$
      ];
      var Data = [];

      // Add data rows with both quantity and value
      financeirasToUse.map((fin, index) => {
        const row = {
          razaoSocial: fin.nomeAgrupamento ? fin.nomeAgrupamento : fin.razaoSocial,
        };

        // Add columns based on dadosPorColuna with both quantity and value
        fin.dadosPorColuna &&
          fin.dadosPorColuna.forEach((colData, colIndex) => {
            if (typeof colData === "object" && colData !== null) {
              // Add both quantity and value for each column
              row[`qtdCol${colIndex}`] = colData.qtd || 0;
              row[`valCol${colIndex}`] = colData.valorERC || 0;
            } else {
              // Old structure value - fallback
              row[`qtdCol${colIndex}`] = colData || 0;
              row[`valCol${colIndex}`] = 0; // No value in old structure
            }
          });

        Data.push(row);
      });

      // Add totals row with both quantity and value
      if (currentData.totalPorColuna) {
        const totalRow = { razaoSocial: "Total" };
        currentData.totalPorColuna.forEach((total, index) => {
          if (typeof total === "object" && total !== null) {
            // Add both quantity and value for totals
            totalRow[`qtdCol${index}`] = total.qtd || 0;
            totalRow[`valCol${index}`] = total.valorERC || 0;
          } else {
            // Old structure - fallback
            totalRow[`qtdCol${index}`] = total || 0;
            totalRow[`valCol${index}`] = 0;
          }
        });
        Data.push(totalRow);
      }

      var ws = XLSX.utils.aoa_to_sheet(Heading);
      // Create header array with both quantity and value columns
      const headerArray = ["razaoSocial", ...currentData.colunas.flatMap((col, idx) => [`qtdCol${idx}`, `valCol${idx}`])];
      XLSX.utils.sheet_add_json(ws, Data, {
        header: headerArray,
        skipHeader: true,
        origin: "A3", // Start from row 3 to accommodate the merged headers
      });

      // Create merge ranges for the month headers
      const merge = [];
      for (let i = 0; i < currentData.colunas.length; i++) {
        merge.push({ s: { r: 0, c: 1 + i * 2 }, e: { r: 0, c: 2 + i * 2 } }); // Merge month header across Qtd and R$
      }
      ws["!merges"] = merge;
    } else {
      // Old structure - fixed columns with both quantity and value
      var Heading = [
        ["", currentData.mes1.toUpperCase(), "", "", currentData.mes2.toUpperCase(), "", "", currentData.mes3.toUpperCase()],
        ["Financeiras", "Qtd", "R$ Alias", "R$ Detran", "Qtd", "R$ Alias", "R$ Detran", "Qtd", "R$ Alias", "R$ Detran"],
      ];
      var Data = [];

      currentData.financeirasAgrupadas &&
        currentData.financeirasAgrupadas.map((fin, index) => {
          Data.push({
            razaoSocial: fin.razaoSocial,
            qtd1: fin.qtdMes1,
            rsAlias1: fin.valorERCMes1,
            rsDetran1: fin.valorDetranMes1,
            qtd2: fin.qtdMes2,
            rsAlias2: fin.valorERCMes2,
            rsDetran2: fin.valorDetranMes2,
            qtd3: fin.qtdMes3,
            rsAlias3: fin.valorERCMes3,
            rsDetran3: fin.valorDetranMes3,
          });
        });
      Data.push(
        {
          razaoSocial: "",
          qtd1: "",
          rsAlias1: "",
          rsDetran1: "",
          qtd2: "",
          rsAlias2: "",
          rsDetran2: "",
          qtd3: "",
          rsAlias3: "",
          rsDetran3: "",
        },
        {
          razaoSocial: "Total",
          qtd1: currentData.qtdTotalMes1,
          rsAlias1: currentData.valorERCTotalMes1,
          rsDetran1: currentData.valorDetranTotalMes1,
          qtd2: currentData.qtdTotalMes2,
          rsAlias2: currentData.valorERCTotalMes2,
          rsDetran2: currentData.valorDetranTotalMes2,
          qtd3: currentData.qtdTotalMes3,
          rsAlias3: currentData.valorERCTotalMes3,
          rsDetran3: currentData.valorDetranTotalMes3,
        },
      );

      var ws = XLSX.utils.aoa_to_sheet(Heading);
      const merge = [
        { s: { r: 0, c: 1 }, e: { r: 0, c: 3 } },
        { s: { r: 0, c: 4 }, e: { r: 0, c: 6 } },
        { s: { r: 0, c: 7 }, e: { r: 0, c: 9 } },
      ];
      ws["!merges"] = merge;
      XLSX.utils.sheet_add_json(ws, Data, {
        header: ["razaoSocial", "qtd1", "rsAlias1", "rsDetran1", "qtd2", "rsAlias2", "rsDetran2", "qtd3", "rsAlias3", "rsDetran3"],
        skipHeader: true,
        origin: "A3",
      });
    }

    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Resultado");
    var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "DashboardFinanceiras-Tabela.xlsx");
  };

  exportToCSVPartialGroup = () => {
    const currentData = this.props.listFilter || this.props.all;

    if (currentData.colunas && currentData.colunas.length > 0) {
      // Nova estrutura - colunas dinâmicas
      let financeirasToUse = [];

      if (currentData.financeirasAgrupadas) {
        currentData.financeirasAgrupadas.forEach((fin) => {
          if (fin.correspondentes && fin.correspondentes.length > 0) {
            // Filtra a financeira mãe do array de correspondentes para a verificação
            const filhas = fin.correspondentes.filter((c) => c.id !== fin.id);
            if (filhas.length > 0) {
              // Verifica se todas as filhas possuem cnpjCorrespondente preenchido
              const allHaveCnpj = filhas.every((c) => c.cnpjCorrespondente && c.cnpjCorrespondente.trim().length > 0);
              if (allHaveCnpj) {
                // AGRUPAR - linha única com dados agregados do pai
                financeirasToUse.push({ ...fin, _displayName: fin.nomeAgrupamento || fin.razaoSocial });
              } else {
                // EXPANDIR - cada correspondente como linha individual
                fin.correspondentes.forEach((corr) => {
                  financeirasToUse.push({ ...corr, _displayName: corr.razaoSocial });
                });
              }
            } else {
              // Só tem a mãe no array - mostra como linha única
              financeirasToUse.push({ ...fin, _displayName: fin.nomeAgrupamento || fin.razaoSocial });
            }
          } else {
            // Sem correspondentes - mostra a financeira
            financeirasToUse.push({ ...fin, _displayName: fin.nomeAgrupamento || fin.razaoSocial });
          }
        });
      } else if (currentData.financeiras) {
        financeirasToUse = currentData.financeiras.map((fin) => ({ ...fin, _displayName: fin.razaoSocial }));
      }

      var Heading = [
        ["", ...currentData.colunas.flatMap((col) => [col.descricao, ""])],
        ["Financeiras", ...currentData.colunas.flatMap((col) => ["Qtd", "R$"])],
      ];
      var Data = [];

      financeirasToUse.forEach((fin) => {
        const row = { razaoSocial: fin._displayName };
        fin.dadosPorColuna &&
          fin.dadosPorColuna.forEach((colData, colIndex) => {
            if (typeof colData === "object" && colData !== null) {
              row[`qtdCol${colIndex}`] = colData.qtd || 0;
              row[`valCol${colIndex}`] = colData.valorERC || 0;
            } else {
              row[`qtdCol${colIndex}`] = colData || 0;
              row[`valCol${colIndex}`] = 0;
            }
          });
        Data.push(row);
      });

      if (currentData.totalPorColuna) {
        const totalRow = { razaoSocial: "Total" };
        currentData.totalPorColuna.forEach((total, index) => {
          if (typeof total === "object" && total !== null) {
            totalRow[`qtdCol${index}`] = total.qtd || 0;
            totalRow[`valCol${index}`] = total.valorERC || 0;
          } else {
            totalRow[`qtdCol${index}`] = total || 0;
            totalRow[`valCol${index}`] = 0;
          }
        });
        Data.push(totalRow);
      }

      var ws = XLSX.utils.aoa_to_sheet(Heading);
      const headerArray = ["razaoSocial", ...currentData.colunas.flatMap((col, idx) => [`qtdCol${idx}`, `valCol${idx}`])];
      XLSX.utils.sheet_add_json(ws, Data, {
        header: headerArray,
        skipHeader: true,
        origin: "A3",
      });

      const merge = [];
      for (let i = 0; i < currentData.colunas.length; i++) {
        merge.push({ s: { r: 0, c: 1 + i * 2 }, e: { r: 0, c: 2 + i * 2 } });
      }
      ws["!merges"] = merge;
    } else {
      // Estrutura antiga - 3 meses fixos
      var Heading = [
        ["", currentData.mes1.toUpperCase(), "", "", currentData.mes2.toUpperCase(), "", "", currentData.mes3.toUpperCase()],
        ["Financeiras", "Qtd", "R$ Alias", "R$ Detran", "Qtd", "R$ Alias", "R$ Detran", "Qtd", "R$ Alias", "R$ Detran"],
      ];
      var Data = [];

      if (currentData.financeirasAgrupadas) {
        currentData.financeirasAgrupadas.forEach((fin) => {
          if (fin.correspondentes && fin.correspondentes.length > 0) {
            // Filtra a financeira mãe do array de correspondentes para a verificação
            const filhas = fin.correspondentes.filter((c) => c.id !== fin.id);
            if (filhas.length > 0) {
              const allHaveCnpj = filhas.every((c) => c.cnpjCorrespondente && c.cnpjCorrespondente.trim().length > 0);
              if (allHaveCnpj) {
                // AGRUPAR
                Data.push({
                  razaoSocial: fin.nomeAgrupamento || fin.razaoSocial,
                  qtd1: fin.qtdMes1,
                  rsAlias1: fin.valorERCMes1,
                  rsDetran1: fin.valorDetranMes1,
                  qtd2: fin.qtdMes2,
                  rsAlias2: fin.valorERCMes2,
                  rsDetran2: fin.valorDetranMes2,
                  qtd3: fin.qtdMes3,
                  rsAlias3: fin.valorERCMes3,
                  rsDetran3: fin.valorDetranMes3,
                });
              } else {
                // EXPANDIR
                fin.correspondentes.forEach((corr) => {
                  Data.push({
                    razaoSocial: corr.razaoSocial,
                    qtd1: corr.qtdMes1,
                    rsAlias1: corr.valorERCMes1,
                    rsDetran1: corr.valorDetranMes1,
                    qtd2: corr.qtdMes2,
                    rsAlias2: corr.valorERCMes2,
                    rsDetran2: corr.valorDetranMes2,
                    qtd3: corr.qtdMes3,
                    rsAlias3: corr.valorERCMes3,
                    rsDetran3: corr.valorDetranMes3,
                  });
                });
              }
            } else {
              // Só tem a mãe no array - mostra como linha única
              Data.push({
                razaoSocial: fin.nomeAgrupamento || fin.razaoSocial,
                qtd1: fin.qtdMes1,
                rsAlias1: fin.valorERCMes1,
                rsDetran1: fin.valorDetranMes1,
                qtd2: fin.qtdMes2,
                rsAlias2: fin.valorERCMes2,
                rsDetran2: fin.valorDetranMes2,
                qtd3: fin.qtdMes3,
                rsAlias3: fin.valorERCMes3,
                rsDetran3: fin.valorDetranMes3,
              });
            }
          } else {
            Data.push({
              razaoSocial: fin.razaoSocial,
              qtd1: fin.qtdMes1,
              rsAlias1: fin.valorERCMes1,
              rsDetran1: fin.valorDetranMes1,
              qtd2: fin.qtdMes2,
              rsAlias2: fin.valorERCMes2,
              rsDetran2: fin.valorDetranMes2,
              qtd3: fin.qtdMes3,
              rsAlias3: fin.valorERCMes3,
              rsDetran3: fin.valorDetranMes3,
            });
          }
        });
      } else if (currentData.financeiras) {
        currentData.financeiras.forEach((fin) => {
          Data.push({
            razaoSocial: fin.razaoSocial,
            qtd1: fin.qtdMes1,
            rsAlias1: fin.valorERCMes1,
            rsDetran1: fin.valorDetranMes1,
            qtd2: fin.qtdMes2,
            rsAlias2: fin.valorERCMes2,
            rsDetran2: fin.valorDetranMes2,
            qtd3: fin.qtdMes3,
            rsAlias3: fin.valorERCMes3,
            rsDetran3: fin.valorDetranMes3,
          });
        });
      }

      Data.push(
        { razaoSocial: "", qtd1: "", rsAlias1: "", rsDetran1: "", qtd2: "", rsAlias2: "", rsDetran2: "", qtd3: "", rsAlias3: "", rsDetran3: "" },
        {
          razaoSocial: "Total",
          qtd1: currentData.qtdTotalMes1,
          rsAlias1: currentData.valorERCTotalMes1,
          rsDetran1: currentData.valorDetranTotalMes1,
          qtd2: currentData.qtdTotalMes2,
          rsAlias2: currentData.valorERCTotalMes2,
          rsDetran2: currentData.valorDetranTotalMes2,
          qtd3: currentData.qtdTotalMes3,
          rsAlias3: currentData.valorERCTotalMes3,
          rsDetran3: currentData.valorDetranTotalMes3,
        },
      );

      var ws = XLSX.utils.aoa_to_sheet(Heading);
      const merge = [
        { s: { r: 0, c: 1 }, e: { r: 0, c: 3 } },
        { s: { r: 0, c: 4 }, e: { r: 0, c: 6 } },
        { s: { r: 0, c: 7 }, e: { r: 0, c: 9 } },
      ];
      ws["!merges"] = merge;
      XLSX.utils.sheet_add_json(ws, Data, {
        header: ["razaoSocial", "qtd1", "rsAlias1", "rsDetran1", "qtd2", "rsAlias2", "rsDetran2", "qtd3", "rsAlias3", "rsDetran3"],
        skipHeader: true,
        origin: "A3",
      });
    }

    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Resultado");
    var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "DashboardFinanceiras-AgrupamentoParcial.xlsx");
  };

  // exportChartToCSV = (type) => {
  //   if (type === "chart1") {
  //     var Heading = [["Financeiras", "Quantidade"]];
  //     var Data = [];

  //     this.props.all.financeiras.map((fin, index) => {
  //       Data.push({
  //         razaoSocial: fin.razaoSocial,
  //         qtd3: fin.qtdMes3,
  //       });
  //     });
  //     Data.push(
  //       { razaoSocial: "", qtd3: "" },
  //       {
  //         razaoSocial: "Total",
  //         qtd3: this.props.all.qtdTotalMes3,
  //       }
  //     );

  //     var ws = XLSX.utils.aoa_to_sheet(Heading);
  //     XLSX.utils.sheet_add_json(ws, Data, {
  //       header: ["razaoSocial", "qtd3"],
  //       skipHeader: true,
  //       origin: "A2",
  //     });

  //     var wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Resultado");
  //     var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //     FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "DashboardFinanceiras-Geral-MesAtual.xlsx");
  //   } else if (type === "chart2") {
  //     var Heading = [["Financeiras", `Quantidade - ${this.props.all.mes1.toUpperCase()}`, `Quantidade - ${this.props.all.mes2.toUpperCase()}`, `Quantidade - ${this.props.all.mes3.toUpperCase()}`]];
  //     var Data = [];

  //     this.props.all.financeiras.map((fin, index) => {
  //       Data.push({
  //         razaoSocial: fin.razaoSocial,
  //         qtd1: fin.qtdMes1,
  //         qtd2: fin.qtdMes2,
  //         qtd3: fin.qtdMes3,
  //       });
  //     });
  //     Data.push(
  //       { razaoSocial: "", qtd1: "", qtd2: "", qtd3: "" },
  //       {
  //         razaoSocial: "Total",
  //         qtd1: this.props.all.qtdTotalMes1,
  //         qtd2: this.props.all.qtdTotalMes2,
  //         qtd3: this.props.all.qtdTotalMes3,
  //       }
  //     );

  //     var ws = XLSX.utils.aoa_to_sheet(Heading);
  //     XLSX.utils.sheet_add_json(ws, Data, {
  //       header: ["razaoSocial", "qtd1", "qtd2", "qtd3"],
  //       skipHeader: true,
  //       origin: "A2",
  //     });

  //     var wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Resultado");
  //     var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //     FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "DashboardFinanceiras-Geral-Ultimos3Meses.xlsx");
  //   } else if (type === "chart3") {
  //     var Heading = [[`Quantidade - ${this.props.all.mes1.toUpperCase()}`, `Quantidade - ${this.props.all.mes2.toUpperCase()}`, `Quantidade - ${this.props.all.mes3.toUpperCase()}`]];
  //     var Data = [];

  //     Data.push({
  //       qtdMes1: this.state.selected._original.qtdMes1,
  //       qtdMes2: this.state.selected._original.qtdMes2,
  //       qtdMes3: this.state.selected._original.qtdMes3,
  //     });

  //     var ws = XLSX.utils.aoa_to_sheet(Heading);
  //     XLSX.utils.sheet_add_json(ws, Data, {
  //       header: ["qtdMes1", "qtdMes2", "qtdMes3"],
  //       skipHeader: true,
  //       origin: "A2",
  //     });

  //     var wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Resultado");
  //     var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //     FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), `DashboardFinanceiras-Unitário-${this.state.selected._original.razaoSocial}-Ultimos3Meses.xlsx`);
  //   } else if (type === "chart4") {
  //     var Heading = [["Dia", "Quantidade"]];
  //     var Data = [];

  //     const filteredDays = this.state.selected._original.qtdPorDia.filter((row, index) => new Date().getDate() >= index + 1);
  //     Data = filteredDays.map((row, index) => {
  //       return { dia: index + 1, qtd: row };
  //     });

  //     var ws = XLSX.utils.aoa_to_sheet(Heading);
  //     XLSX.utils.sheet_add_json(ws, Data, {
  //       header: ["dia", "qtd"],
  //       skipHeader: true,
  //       origin: "A2",
  //     });

  //     var wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Resultado");
  //     var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //     FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), `DashboardFinanceiras-Unitário-${this.state.selected._original.razaoSocial}-MesAtual.xlsx`);
  //   }
  // };

  exportToPDF(type) {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 30;
    const doc = new jsPDF(orientation, unit, size);

    var width = doc.internal.pageSize.getWidth();
    var height = doc.internal.pageSize.getHeight();
    doc.page = 1;

    doc.setFontSize(12);

    var startTableY = 50;

    var footer = function () {
      //print number bottom right

      doc.setFontSize(7);
      doc.text(width - 50, height - 30, "Página " + doc.page);
      doc.page++;
    };

    var drawCell = function (data) {
      var doc = data.doc;
      var rows = data.table.body;
      if (data.row.index === rows.length - 1) {
        doc.setTextColor(255, 255, 255);
        doc.setFontStyle("bold");
        doc.setFillColor(80, 80, 80);
      }
    };

    if (type === "table") {
      var title = `Relatório de Contratos E-Registro`;

      const head = [
        [
          { content: "", colSpan: 1 },
          { content: this.props.all.mes1, colSpan: 3 },
          { content: this.props.all.mes2, colSpan: 3 },
          { content: this.props.all.mes3, colSpan: 3 },
        ],
        ["Financeiras", `Qtd`, `R$ Alias`, `R$ Detran`, `Qtd`, `R$ Alias`, `R$ Detran`, `Qtd`, `R$ Alias`, `R$ Detran`],
      ];

      const data = this.props.all.financeiras.map((row) => [
        row.razaoSocial,
        row.qtdMes1,
        MaskDecimal.TO_BRL(row.valorERCMes1),
        MaskDecimal.TO_BRL(row.valorDetranMes1),
        row.qtdMes2,
        MaskDecimal.TO_BRL(row.valorERCMes2),
        MaskDecimal.TO_BRL(row.valorDetranMes2),
        row.qtdMes3,
        MaskDecimal.TO_BRL(row.valorERCMes3),
        MaskDecimal.TO_BRL(row.valorDetranMes3),
      ]);

      const dataWithFinal = [
        ...data,
        [
          "TOTAL",
          this.props.all.qtdTotalMes1,
          MaskDecimal.TO_BRL(this.props.all.valorERCTotalMes1),
          MaskDecimal.TO_BRL(this.props.all.valorDetranTotalMes1),
          this.props.all.qtdTotalMes2,
          MaskDecimal.TO_BRL(this.props.all.valorERCTotalMes2),
          MaskDecimal.TO_BRL(this.props.all.valorDetranTotalMes2),
          this.props.all.qtdTotalMes3,
          MaskDecimal.TO_BRL(this.props.all.valorERCTotalMes3),
          MaskDecimal.TO_BRL(this.props.all.valorDetranTotalMes3),
        ],
      ];

      let content = {
        startY: startTableY,
        willDrawCell: drawCell,
        head,
        body: dataWithFinal,
        bodyStyles: { valign: "top" },
        styles: {
          cellPadding: 1.5,
          overflow: "linebreak",
          valign: "middle",
          halign: "center",
          lineColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        didDrawPage: function (data) {
          footer();
        },
      };

      doc.text(title, marginLeft, 30);
      doc.autoTable(content);
      doc.save(`DashboardFinanceiras-Tabela.pdf`);
    } else if (type === "chart") {
      if (this.state.unit) {
        var titleUnitTable1 = `Relatório de Contratos E-Registro - ${this.state.selected._original.razaoSocial} - 3 Meses`;

        const headUnitTable1 = [[{ content: `Quantidade - ${this.props.all.mes1}` }, { content: `Quantidade - ${this.props.all.mes2}` }, { content: `Quantidade - ${this.props.all.mes3}` }]];

        const dataUnitTable1 = [[this.state.selected._original.qtdMes1, this.state.selected._original.qtdMes2, this.state.selected._original.qtdMes3]];

        let contentUnitTable1 = {
          startY: startTableY,
          head: headUnitTable1,
          body: dataUnitTable1,
          bodyStyles: { valign: "top" },
          styles: {
            cellPadding: 1.5,
            overflow: "linebreak",
            valign: "middle",
            halign: "center",
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
          },
          didDrawPage: function (data) {
            footer();
          },
        };

        doc.autoTable(contentUnitTable1);

        doc.text(titleUnitTable1, marginLeft, 30);

        //Segunda tabela do tipo unitário

        const headUnitTable2 = [[{ content: "Dia" }, { content: "Quantidade" }]];

        const filteredDays = this.state.selected._original.qtdPorDia.filter((row, index) => new Date().getDate() >= index + 1);
        const dataUnitTable2 = filteredDays.map((row, index) => [index + 1, row]);

        var titleUnitTable2 = `Relatório de Contratos E-Registro - ${this.state.selected._original.razaoSocial} - Mês - ${this.props.all.mes3}`;

        doc.text(titleUnitTable2, marginLeft, doc.autoTable.previous.finalY + 30);

        let contentUnitTable2 = {
          startY: doc.autoTable.previous.finalY + 50,
          head: headUnitTable2,
          body: dataUnitTable2,
          bodyStyles: { valign: "top" },
          styles: {
            cellPadding: 1.5,
            overflow: "linebreak",
            valign: "middle",
            halign: "center",
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
          },
          didDrawPage: function (data) {
            footer();
          },
        };
        doc.autoTable(contentUnitTable2);

        doc.save(`RelatorioContratos-${this.state.selected._original.razaoSocial}-UnitarioMes-${this.props.all.mes3}.pdf`);
      } else {
        var titleTable1 = `Relatório de Contratos E-Registro - Geral Mês`;

        const headTable1 = [[{ content: "Financeira" }, { content: "Quantidade" }]];

        const dataTable1 = this.props.all.financeiras.map((row) => [row.razaoSocial, row.qtdMes3]);

        let contentTable1 = {
          startY: startTableY,
          head: headTable1,
          body: dataTable1,
          bodyStyles: { valign: "top" },
          styles: {
            cellPadding: 1.5,
            overflow: "linebreak",
            valign: "middle",
            halign: "center",
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
          },
          didDrawPage: function (data) {
            footer();
          },
        };

        doc.autoTable(contentTable1);

        doc.text(titleTable1, marginLeft, 30);

        const headTable2 = [
          [{ content: "Financeira" }, { content: `Quantidade - ${this.props.all.mes1}` }, { content: `Quantidade - ${this.props.all.mes2}` }, { content: `Quantidade - ${this.props.all.mes3}` }],
        ];

        const dataTable2 = this.props.all.financeiras.map((row) => [row.razaoSocial, row.qtdMes1, row.qtdMes2, row.qtdMes3]);

        var titleTable2 = `Relatório de Contratos E-Registro - 3 Meses`;
        doc.text(titleTable2, marginLeft, doc.autoTable.previous.finalY + 30);

        let contentTable2 = {
          startY: doc.autoTable.previous.finalY + 50,
          head: headTable2,
          body: dataTable2,
          bodyStyles: { valign: "top" },
          styles: {
            cellPadding: 1.5,
            overflow: "linebreak",
            valign: "middle",
            halign: "center",
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
          },
          didDrawPage: function (data) {
            footer();
          },
        };
        doc.autoTable(contentTable2);
        doc.save(`RelatorioContratos-GeralMes-${this.props.all.mes3}.pdf`);
      }
    }
  }

  exportFinInvalidasToCSV() {
    var head = [["Razão Social", "UF", "Data último registro", "Financeira Mãe"]];

    var ref = ["razaoSocial", "uf", "ultimaCobranca", "financeiraMae"];
    var fileName = "RelatorioFinanceirasInativas";
    var data = [];

    for (const fin of this.props.listFinancialInvalid) {
      var result = fin.financeiraFilha.map((row) => {
        return {
          razaoSocial: row.filha,
          uf: row.uf,
          ultimaCobranca: MaskDate.TO_BR(row.ultimaCobranca),
          financeiraMae: row.raiz !== row.filha ? row.raiz : "",
        };
      });
      data = data.concat(result);
    }

    var ws = XLSX.utils.aoa_to_sheet(head);
    XLSX.utils.sheet_add_json(ws, data, {
      header: ref,
      skipHeader: true,
      origin: "A2",
    });

    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Resultado");
    var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${fileName}.xlsx`);
  }

  async filterUf(value) {
    const { reset } = this.props;
    var uf = value.uf;
    await Promise.resolve(api.Management.dashboardFinancial(null, null, value.uf, this.props.currentUser.idParceiro)).then(async (res) => {
      // Sort financeiras by total value (sum of all columns) - fallback to old method if new structure not available
      if (res.financeirasAgrupadas && res.financeirasAgrupadas.length > 0) {
        if (res.financeirasAgrupadas[0].dadosPorColuna) {
          this.sortFinanceirasByTotal(res.financeirasAgrupadas, this.state.exibirValores);
        } else {
          // Legacy fallback for old API structure
          res.financeirasAgrupadas.sort((a, b) => (a.qtdMes3 < b.qtdMes3 ? 1 : a.qtdMes3 > b.qtdMes3 ? -1 : 0));
        }
      }
      this.props.onListLoad(res);
      this.props.onListLoadFilter(null);
      let resFilter = await this.filterListByParam({ ...this.props.all }, 20);
      this.props.dispatch(change("FinancialDashboardForm", "periodicidade", "2"));
      this.props.onListLoadFilter(resFilter);
      this.props.onCompaniesLoad([{ cnpj: 0, razaoSocial: "Todos" }, ...res.financeiras]);
      if (this.props.anyTouched) reset();
      this.props.dispatch(change("FinancialDashboardForm", "uf", uf));
    });

    this.props.onContractClearImageVisao();
    //document.getElementById("top").click();
    //document.getElementById("geral").click();
    this.setState({
      contractsNotRegistred: 0,
      contractsRegistredError: 0,
      contractsRegistredWithoutImage: 0,
      contractsRegistred: 0,
      contractsCancel: 0,
    });
    //this.handleContractImages({cnpj:0, uf:value.uf});
  }

  async handleCotractView(values) {
    if (values.cnpj2) {
      this.setState({ credor: values.cnpj2.cnpj, pesquisando: true });
      toastr.info("Aguarde", "Realizando consulta...", {
        timeOut: 0,
        component: () => {
          return <BeatLoader size={15} margin={2} color={"#58abc3"} loading={true} />;
        },
      });
      var props = this.props;
      await Promise.resolve(api.Contracts.getQtdVisaoGeral(values.cnpj2.cnpj, values.uf == "Todas" ? undefined : values.uf))
        .then((res) => {
          this.setState({ pesquisando: false });
          toastr.removeByType("info");
          if (res.length > 0) {
            this.setState({
              contractsNotRegistred: res.filter((element) => element.status == "naoEnviadoEmProc")[0],
              contractsRegistredError: res.filter((element) => element.status == "comErro")[0],
              contractsRegistredWithoutImage: res.filter((element) => element.status == "registradoSemImagem")[0],
              contractsRegistred: res.filter((element) => element.status == "registrado")[0],
              contractsCancel: res.filter((element) => element.status == "canceladoBaixado")[0],
            });
          } else {
            toastr.info("Aviso", "Não foram encontrados resultados para essa pesquisa.");
          }
        })
        .catch((e) => {
          this.setState({ pesquisando: false });
          toastr.removeByType("info");
          if (e === "Unauthorized" || e === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else {
            toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
          }
        });
    }
  }

  handleContractImages(values) {
    if (values.cnpj) {
      this.setState({ credor: values.cnpj.cnpj, pesquisando: true });
      toastr.info("Aguarde", "Realizando consulta...", {
        timeOut: 0,
        component: () => {
          return <BeatLoader size={15} margin={2} color={"#58abc3"} loading={true} />;
        },
      });

      var props = this.props;
      Promise.resolve(api.Contracts.getQtdImagensContratos(values.cnpj.cnpj, values.uf == "Todas" ? undefined : values.uf))
        .then((res) => {
          let contractsExpired = {
            qtd: 0,
          };
          let contractsExpired7 = {
            qtd: 0,
          };
          let contractsExpired15 = {
            qtd: 0,
          };
          let contractsExpired30 = {
            qtd: 0,
          };
          this.setState({ pesquisando: false });
          toastr.removeByType("info");
          if (res.length > 0) {
            contractsExpired.qtd += res.filter((element) => element.vencido == "vencido30")[0].qtd;
            contractsExpired.data = res.filter((element) => element.vencido == "vencido30")[0].data;
            contractsExpired7.qtd += res.filter((element) => element.vencido == "vencerEm7")[0].qtd;
            contractsExpired7.data = res.filter((element) => element.vencido == "vencerEm7")[0].data;
            contractsExpired15.qtd += res.filter((element) => element.vencido == "vencerEm15")[0].qtd;
            contractsExpired15.data = res.filter((element) => element.vencido == "vencerEm15")[0].data;
            contractsExpired30.qtd += res.filter((element) => element.vencido == "vencerEm30")[0].qtd;
            contractsExpired30.data = res.filter((element) => element.vencido == "vencerEm30")[0].data;
          } else {
            toastr.info("Aviso", "Não foram encontrados resultados para essa pesquisa.");
          }
          this.props.onContractsExpiredLoad(contractsExpired);
          this.props.onContractsExpired7Load(contractsExpired7);
          this.props.onContractsExpired15Load(contractsExpired15);
          this.props.onContractsExpired30Load(contractsExpired30);
        })
        .catch((e) => {
          this.setState({ pesquisando: false });
          toastr.removeByType("info");
          if (e === "Unauthorized" || e === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else {
            toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
          }
        });
    }
  }

  render() {
    const { handleSubmit, reset } = this.props;
    const { otherValuesSelected, selected } = this.state;
    // var data1,
    //   data2,
    //   data3,
    //   data4 = [];

    // if (this.props.all && this.props.all.financeirasAgrupadas) {
    //   data1 = {
    //     labels: this.props.all.financeirasAgrupadas.map((f, index) => {
    //       return f.razaoSocial;
    //     }),
    //     datasets: [
    //       {
    //         label: "Contratos Registrados",
    //         backgroundColor: "rgba(24,73,170,0.2)",
    //         borderColor: "rgba(24,73,170,1)",
    //         borderWidth: 1,
    //         hoverBackgroundColor: "rgba(24,73,170,0.4)",
    //         hoverBorderColor: "rgba(24,73,170,1)",
    //         data: this.props.all.financeirasAgrupadas.map((f, index) => {
    //           return f.qtdMes3;
    //         }),
    //       },
    //     ],
    //   };
    //   data2 = {
    //     labels: this.props.all.financeirasAgrupadas.map((f, index) => {
    //       return f.razaoSocial;
    //     }),
    //     datasets: [
    //       {
    //         label: this.props.all.mes1,
    //         backgroundColor: "#3366ff",
    //         data: this.props.all.financeirasAgrupadas.map((f, index) => {
    //           return f.qtdMes1;
    //         }),
    //       },
    //       {
    //         label: this.props.all.mes2,
    //         backgroundColor: "#F2910C",
    //         data: this.props.all.financeirasAgrupadas.map((f, index) => {
    //           return f.qtdMes2;
    //         }),
    //       },
    //       {
    //         label: this.props.all.mes3,
    //         backgroundColor: "#92d400",
    //         data: this.props.all.financeirasAgrupadas.map((f, index) => {
    //           return f.qtdMes3;
    //         }),
    //       },
    //     ],
    //   };
    //   switch (this.state.top10) {
    //     case "values":
    //       //Chart 1
    //       var filteredByValue = this.props.all.financeirasAgrupadas
    //         .slice()
    //         .sort((a, b) => b.valorERCMes3 - a.valorERCMes3)
    //         .filter((value, index) => index < 10 && value);
    //       var data = filteredByValue.map((f, index) => {
    //         return MaskDecimal.TO_BR_NO_DOTS(f.valorERCMes3);
    //       });
    //       var labels = filteredByValue.map((f, index) => {
    //         return f.razaoSocial;
    //       });

    //       data1 = {
    //         labels,
    //         datasets: [{ ...data1.datasets[0], label: "Valor em R$", data }],
    //       };

    //       //Chart 2
    //       var filteredByValue2 = this.props.all.financeirasAgrupadas
    //         .slice()
    //         .sort((a, b) => b.valorERCMes1 + b.valorERCMes2 + b.valorERCMes3 - (a.valorERCMes1 + a.valorERCMes2 + a.valorERCMes3))
    //         .filter((value, index) => index < 10 && value);
    //       var data2_mes1 = filteredByValue2.map((f, index) => {
    //         return MaskDecimal.TO_BR_NO_DOTS(f.valorERCMes1);
    //       });
    //       var data2_mes2 = filteredByValue2.map((f, index) => {
    //         return MaskDecimal.TO_BR_NO_DOTS(f.valorERCMes2);
    //       });
    //       var data2_mes3 = filteredByValue2.map((f, index) => {
    //         return MaskDecimal.TO_BR_NO_DOTS(f.valorERCMes3);
    //       });
    //       var labels2 = filteredByValue2.map((f, index) => {
    //         return f.razaoSocial;
    //       });

    //       var datasets = [
    //         {
    //           ...data2.datasets[0],
    //           data: data2_mes1,
    //           label: `Valor de ${this.props.all.mes1} em R$`,
    //         },
    //         {
    //           ...data2.datasets[1],
    //           data: data2_mes2,
    //           label: `Valor de ${this.props.all.mes2} em R$`,
    //         },
    //         {
    //           ...data2.datasets[2],
    //           data: data2_mes3,
    //           label: `Valor de ${this.props.all.mes3} em R$`,
    //         },
    //       ];
    //       data2 = { labels: labels2, datasets };
    //       break;
    //     case "qtd":
    //       //Chart 1
    //       var filteredByQuantity = this.props.all.financeirasAgrupadas
    //         .slice()
    //         .sort((a, b) => b.qtdMes3 - a.qtdMes3)
    //         .filter((value, index) => index < 10 && value);
    //       var data = filteredByQuantity.map((f, index) => {
    //         return f.qtdMes3;
    //       });
    //       var labels = filteredByQuantity.map((f, index) => {
    //         return f.razaoSocial;
    //       });

    //       data1 = { labels, datasets: [{ ...data1.datasets[0], data }] };

    //       //Chart 2
    //       var filteredByQuantity2 = this.props.all.financeirasAgrupadas
    //         .slice()
    //         .sort((a, b) => b.qtdMes1 + b.qtdMes2 + b.qtdMes3 - (a.qtdMes1 + a.qtdMes2 + a.qtdMes3))
    //         .filter((value, index) => index < 10 && value);
    //       var data2_mes1 = filteredByQuantity2.map((f, index) => {
    //         return f.qtdMes1;
    //       });
    //       var data2_mes2 = filteredByQuantity2.map((f, index) => {
    //         return f.qtdMes2;
    //       });
    //       var data2_mes3 = filteredByQuantity2.map((f, index) => {
    //         return f.qtdMes3;
    //       });
    //       var labels2 = filteredByQuantity2.map((f, index) => {
    //         return f.razaoSocial;
    //       });

    //       var datasets = [
    //         { ...data2.datasets[0], data: data2_mes1 },
    //         { ...data2.datasets[1], data: data2_mes2 },
    //         { ...data2.datasets[2], data: data2_mes3 },
    //       ];
    //       data2 = { labels: labels2, datasets };
    //       break;
    //     default:
    //       break;
    //   }

    //   if (this.state.selected) {
    //     data3 = {
    //       labels: [this.props.all.mes1, this.props.all.mes2, this.props.all.mes3],
    //       datasets: [
    //         {
    //           label: this.state.selected._original.razaoSocial,
    //           backgroundColor: "rgba(24,73,170,0.2)",
    //           borderColor: "rgba(24,73,170,1)",
    //           borderWidth: 1,
    //           hoverBackgroundColor: "rgba(24,73,170,0.4)",
    //           hoverBorderColor: "rgba(24,73,170,1)",
    //           data: [this.state.selected._original.qtdMes1, this.state.selected._original.qtdMes2, this.state.selected._original.qtdMes3],
    //         },
    //       ],
    //     };
    //   }
    //   if (this.state.selected && this.state.unit) {
    //     const data = JSON.parse(JSON.stringify(this.state.selected._original.qtdPorDia));
    //     data4 = {
    //       labels: this.props.all.arrayDias,
    //       datasets: [
    //         {
    //           label: `${this.state.selected._original.razaoSocial} - ${this.props.all.mes3}`,
    //           backgroundColor: "rgba(24,73,170,0.2)",
    //           borderColor: "rgba(24,73,170,1)",
    //           borderWidth: 1,
    //           hoverBackgroundColor: "rgba(24,73,170,0.4)",
    //           hoverBorderColor: "rgba(24,73,170,1)",
    //           data,
    //         },
    //       ],
    //     };
    //   }
    // }

    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="" />{" "}
        <div className="content">
          <div className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <div className="row">
                    <div className="col-md-2">
                      <Field name="uf" label="UF" data={this.props.ufSystem} textField="sigla" component={SelectField} type="text" />
                    </div>
                    <div className="col-lg-1 align-self-end form-group">
                      <button className="btn btn-success" onClick={handleSubmit(this.filterUf.bind(this))} type="button">
                        Filtrar
                      </button>
                    </div>
                  </div>
                  <div className="panel-tools"></div>
                  <p>Dashboard</p>
                </div>
                <div className="panel-body">
                  <div>
                    {/*<label>Maiores detalhes</label>
                  <input
                    name="otherValues"
                    type="checkbox"
                    checked={this.state.otherValuesSelected}
                    onChange={this.handleInputChange.bind(this)}
                />*/}

                    <form onSubmit={handleSubmit(this.handleFilterChart.bind(this))}>
                      <div className="row">
                        {/* <div className="col-lg-3">
                          <Field name="trimestre" label="Trimestre" data={trimestres} textField="label" valueField="value" component={SelectField} type="text" />
                        </div> */}
                        <div className="col-lg-2">
                          <Field name="ano" label="Ano" data={OtherUtils.yearsWithOptSel} textField="label" valueField="value" component={SelectField} type="text" />
                        </div>
                        <div className="col-lg-2">
                          <Field
                            name="mes"
                            label="Mês"
                            data={OtherUtils.monthsWithOptSel}
                            textField="label"
                            valueField="value"
                            component={SelectField}
                            type="text"
                            textTooltip="Exibe todos os dias do ano/mês selecionado."
                          />
                        </div>
                        <div className="col-lg-2">
                          <Field
                            name="periodo"
                            label="Período"
                            data={[
                              { value: "", label: "Selecione" },
                              { value: "1", label: "Semestral" },
                              { value: "2", label: "Mensal" },
                            ]}
                            textField="label"
                            valueField="value"
                            component={SelectField}
                            type="text"
                            textTooltip="Semestral: Exibe os semestres do ano selecionado. Mensal: Exibe os meses do ano selecionado."
                          />
                        </div>
                        <div className="col-lg-2">
                          <Field name="tipo" label="Tipo de Financeira" data={OtherUtils.financialTypes} valueField="id" textField="name" component={SelectField} type="text" />
                        </div>
                        {!this.props.currentUser.idCarteira && (
                          <div className="col-lg-2">
                            <Field
                              name="idsCarteira"
                              label="Carteiras"
                              data={this.state.carteiras.filter((c) => c.id)}
                              valueField="id"
                              textField="nome"
                              component={MultiSelectField}
                              type="text"
                            />
                          </div>
                        )}
                        <div className="col-lg-2 align-self-end form-group">
                          {/* <button className="btn btn-secondary" type="button" onClick={handleSubmit(this.handleDefaultChart.bind(this))}>
                            Últimos 3 Meses
                          </button> */}
                          &nbsp;&nbsp;&nbsp;
                          <button disabled={this.props.inProgress || this.props.submitting || this.props.invalid || this.state.pesquisando} className="btn btn-success" type="submit">
                            {this.state.pesquisando ? "Aguarde..." : "Pesquisar"}
                          </button>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-3">
                          <Field name="periodicidade" label="Exibir" data={periodicidade} textField="label" valueField="value" component={SelectField} type="text" />
                        </div>
                        <div className="col-lg-6 align-self-end form-group">
                          <button className="btn btn-success" type="button" onClick={handleSubmit(this.filtrarPeriodicidade.bind(this))}>
                            Filtrar
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  {/* Botões de ação acima da tabela */}
                  {this.props.listFilter && this.props.listFilter.financeirasAgrupadas && (
                    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px", gap: "5px" }}>
                      {this.props.currentUser.funcionalidades.includes(5) && (
                        <Link className="btn btn-default" checked={this.state.otherValuesSelected} onClick={this.handleInputChange.bind(this)} title="Alternar entre R$ e Qtd">
                          <SvgIcon size={20} icon={ic_attach_money} />
                        </Link>
                      )}
                      {this.props.currentUser.funcionalidades.includes(7) && (
                        <Link className="btn btn-default" onClick={this.exportToCSV.bind(this)} title="Gerar Excel">
                          <SvgIcon size={20} icon={fileExcelO} />
                        </Link>
                      )}
                      {this.props.currentUser.funcionalidades.includes(8) && (
                        <Link className="btn btn-default" onClick={this.exportToCSVGroup.bind(this)} title="Gerar Excel Agrupado">
                          <SvgIcon size={20} icon={stack} />
                        </Link>
                      )}
                      {this.props.currentUser.funcionalidades.includes(8) && (
                        <Link className="btn btn-default" onClick={this.exportToCSVPartialGroup.bind(this)} title="Gerar Excel Agrupamento Parcial">
                          <SvgIcon size={20} icon={stack} />
                        </Link>
                      )}
                    </div>
                  )}
                  {/* Tabela */}
                  <div>
                    {this.props.listFilter && this.props.listFilter.financeirasAgrupadas && this.props.listFilter.colunas ? this.renderSpreadsheetTable() : <small>Nenhum registro encontrado</small>}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div ref={(ref) => (this.myRef = ref)} className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <div className="panel-tools">
                    <Link className="btn btn-default btn-sm" onClick={() => this.exportToPDF("chart")} title={`Gerar PDF de Ambos os Gráficos ${this.state.unit ? "Unitários" : "Gerais"}`}>
                      {" "}
                      <SvgIcon icon={filePdf} />
                    </Link>
                    <span>
                      <butto id="top" style={{ display: "none" }} onClick={(e) => this.handleChangeTopFake10("qtd")} />
                      <button id="geral" style={{ display: "none" }} onClick={(e) => this.handleChangeTopFake10("all")} />

                      <button className="btn btn-default btn-sm" onClick={(e) => this.handleChangeTop10("qtd")}>
                        Top 10 Quantidade
                      </button>
                      <button className="btn btn-default btn-sm" onClick={(e) => this.handleChangeTop10("values")}>
                        Top 10 Valores
                      </button>
                      <button className="btn btn-default btn-sm" onClick={(e) => this.handleChangeTop10("all")}>
                        Geral
                      </button>
                    </span>
                    {this.props.all.financeirasAgrupadas && this.state.selected && (
                      <button
                        className="btn btn-default btn-sm"
                        onClick={(e) => {
                          window.scrollTo(0, this.myRef.offsetTop + 50);
                          this.setState({ unit: !this.state.unit });
                        }}
                      >
                        Ir para Visualização {this.state.unit ? "Geral" : "Unitária"}
                      </button>
                    )}
                  </div>
                  <p>Gráficos {!this.state.unit ? "Gerais" : "Unitários"}</p>
                </div>
                {this.props.all.financeirasAgrupadas && !this.state.unit && (
                  <div>
                    <div className="panel-body">
                      <div className="stats-title">
                        <h4>
                          {this.props.all.mes3.toUpperCase()}
                          &nbsp;
                          <Link className="btn btn-default btn-sm" onClick={() => this.exportChartToCSV("chart1")} title="Gerar Excel">
                            {" "}
                            <SvgIcon icon={fileExcelO} />
                          </Link>
                        </h4>
                      </div>
                      <br></br>
                      <div className="row">
                        <div className="col-lg-12">
                          {this.state.top10 === "qtd" && this.renderHorizontalBarData1(data1)}
                          {this.state.top10 === "values" && this.renderHorizontalBarData1(data1)}
                          {this.state.top10 === "all" && this.renderHorizontalBarData1(data1)}
                        </div>
                      </div>
                    </div>
                    <div className="panel-body">
                      <div className="stats-title">
                        <h4>
                          3 meses &nbsp;
                          <Link className="btn btn-default btn-sm" onClick={() => this.exportChartToCSV("chart2")} title="Gerar Excel">
                            {" "}
                            <SvgIcon icon={fileExcelO} />
                          </Link>
                        </h4>
                      </div>
                      <br></br>
                      <div className="row">
                        <div className="col-lg-12">
                          {this.state.top10 === "qtd" && this.renderHorizontalBarData2(data2)}
                          {this.state.top10 === "values" && this.renderHorizontalBarData2(data2)}
                          {this.state.top10 === "all" && this.renderHorizontalBarData2(data2)}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {this.props.all.financeirasAgrupadas && this.state.selected && this.state.unit && (
                  <div>
                    <div className="panel-body">
                      <div className="stats-title">
                        <h4>
                          3 meses e {this.props.all.mes3.toUpperCase()}
                          &nbsp;
                          <Link className="btn btn-default btn-sm" onClick={() => this.exportChartToCSV("chart3")} title="Gerar Excel do Primeiro Gráfico">
                            {" "}
                            <SvgIcon icon={fileExcelO} />
                          </Link>
                          <Link className="btn btn-default btn-sm" onClick={() => this.exportChartToCSV("chart4")} title="Gerar Excel do Segundo Gráfico">
                            {" "}
                            <SvgIcon icon={fileExcelO} />
                          </Link>
                        </h4>
                      </div>

                      <br></br>
                      <div className="row">
                        <div className="col-lg-3">
                          <Bar
                            data={data3}
                            height={400}
                            options={{
                              tooltips: {
                                titleFontColor: "#E0E0E0",
                                callbacks: {
                                  title: function (tooltipItem, data) {
                                    return data["labels"][tooltipItem[0]["index"]];
                                  },
                                  label: function (tooltipItem, data) {
                                    return `Contratos Registrados: ${data["datasets"][0]["data"][tooltipItem["index"]]}`;
                                  },
                                },
                              },
                              maintainAspectRatio: false,
                            }}
                          />
                        </div>
                        <div className="col-lg-9">
                          <Line
                            data={data4}
                            height={400}
                            options={{
                              scales: {
                                yAxes: [
                                  {
                                    ticks: {
                                      stepSize: Math.max(...this.state.selected._original.qtdPorDia) <= 10 ? 1 : undefined,
                                    },
                                  },
                                ],
                              },
                              tooltips: {
                                titleFontColor: "#E0E0E0",
                                callbacks: {
                                  title: function (tooltipItem, data) {
                                    return `Dia ${data["labels"][tooltipItem[0]["index"]]}`;
                                  },
                                  label: function (tooltipItem, data) {
                                    return `Contratos Registrados: ${data["datasets"][0]["data"][tooltipItem["index"]]}`;
                                  },
                                },
                              },
                              maintainAspectRatio: false,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div> */}
          <div className="row justify-content-center">
            {this.props.currentUser.funcionalidades.includes(2) && (
              <div className="col-md-4">
                <div className="hpanel stats">
                  <div className="panel-heading">
                    <div className="panel-tools"></div>
                    <p>Imagens</p>
                  </div>
                  <div className="panel-body h-100">
                    <div className="row m-b-sm">
                      <div className="col-md-12">
                        <div className="stats-title float-left">
                          {" "}
                          <h3>IMAGENS DE REGISTRO DE CONTRATOS</h3>{" "}
                        </div>
                      </div>
                    </div>
                    <form onSubmit={handleSubmit(this.handleContractImages.bind(this))}>
                      <div className="row">
                        <div className="col-md-8">
                          <Field name="cnpj" blank={true} label="Credor" data={this.props.companies} textField="razaoSocial" valueField="cnpj" component={DropdownListField} type="text" />
                        </div>
                        <div className="col-lg-2 align-self-end form-group">
                          <button disabled={this.props.inProgress || this.props.submitting || this.props.invalid || this.state.pesquisando} className="btn btn-success" type="submit">
                            {this.state.pesquisando ? "Aguarde..." : "Pesquisar"}
                          </button>
                        </div>
                        <div className="col-lg-2">&nbsp;</div>
                      </div>
                    </form>
                    <div className="row">
                      <div className="col-md-8">
                        <div className="font-bold float-left">Vencidos</div>
                        <br />
                        <ul className="list-group m-t-sm">
                          <li className="list-group-item">
                            <div className="d-flex justify-content-between">
                              <div>Mais de 30 Dias</div>
                              <div>
                                {this.props.contractsExpired.qtd > 0 ? (
                                  <Link
                                    className="font-weight-bold float-left text-danger"
                                    to={`/alias/aprove/${MaskDate.TO_DATABASE_DATE(this.props.contractsExpired.data[0])}/${this.state.credor}/${this.props.selectedUf}`}
                                  >
                                    {this.props.contractsExpired.qtd}
                                  </Link>
                                ) : (
                                  "0"
                                )}
                              </div>
                            </div>
                          </li>
                        </ul>
                        <br></br>
                        <div className="font-bold float-left">A Vencer</div>
                        <br />
                        <ul className="list-group m-t-sm">
                          <li className="list-group-item">
                            <div className="d-flex justify-content-between">
                              <div>Em 7 Dias</div>
                              <div>
                                {this.props.contractsExpired7.qtd > 0 ? (
                                  <Link
                                    className="font-weight-bold float-left text-danger"
                                    to={`/alias/aprove/${MaskDate.TO_DATABASE_DATE(this.props.contractsExpired7.data[0])}/${MaskDate.TO_DATABASE_DATE(this.props.contractsExpired7.data[1])}/${
                                      this.state.credor
                                    }/${this.props.selectedUf}`}
                                  >
                                    {this.props.contractsExpired7.qtd}
                                  </Link>
                                ) : (
                                  "0"
                                )}
                              </div>
                            </div>
                          </li>
                          <li className="list-group-item">
                            <div className="d-flex justify-content-between">
                              <div>Em 15 Dias</div>
                              <div>
                                {this.props.contractsExpired15.qtd > 0 ? (
                                  <Link
                                    className="font-weight-bold float-left text-danger"
                                    to={`/alias/aprove/${MaskDate.TO_DATABASE_DATE(this.props.contractsExpired15.data[0])}/${MaskDate.TO_DATABASE_DATE(this.props.contractsExpired15.data[1])}/${
                                      this.state.credor
                                    }/${this.props.selectedUf}`}
                                  >
                                    {this.props.contractsExpired15.qtd}
                                  </Link>
                                ) : (
                                  "0"
                                )}
                              </div>
                            </div>
                          </li>
                          <li className="list-group-item">
                            <div className="d-flex justify-content-between">
                              <div>Em 30 Dias</div>
                              <div>
                                {this.props.contractsExpired30.qtd > 0 ? (
                                  <Link
                                    className="font-weight-bold float-left text-danger"
                                    to={`/alias/aprove/${MaskDate.TO_DATABASE_DATE(this.props.contractsExpired30.data[0])}/${MaskDate.TO_DATABASE_DATE(this.props.contractsExpired30.data[1])}/${
                                      this.state.credor
                                    }/${this.props.selectedUf}`}
                                  >
                                    {this.props.contractsExpired30.qtd}
                                  </Link>
                                ) : (
                                  "0"
                                )}
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.props.currentUser.funcionalidades.includes(3) && (
              <div className="col-md-4">
                <div className="hpanel stats">
                  <div className="panel-heading">
                    <div className="panel-tools"></div>
                    <p>Contratos</p>
                  </div>
                  <div className="panel-body h-100">
                    <div className="row m-b-sm">
                      <div className="col-md-12">
                        <div className="stats-title float-left">
                          {" "}
                          <h3>VISÃO GERAL DE CONTRATOS</h3>{" "}
                        </div>
                      </div>
                    </div>
                    <form onSubmit={handleSubmit(this.handleCotractView.bind(this))}>
                      <div className="row">
                        <div className="col-md-8">
                          <Field
                            name="cnpj2"
                            blank={true}
                            label="Credor"
                            data={this.props.companies}
                            textField="razaoSocial"
                            credor={true}
                            valueField="cnpj2"
                            component={DropdownListField}
                            type="text"
                          />
                        </div>
                        <div className="col-lg-2 align-self-end form-group">
                          <button disabled={this.props.inProgress || this.props.submitting || this.props.invalid || this.state.pesquisando} className="btn btn-success" type="submit">
                            {this.state.pesquisando ? "Aguarde..." : "Pesquisar"}
                          </button>
                        </div>
                        <div className="col-lg-2">&nbsp;</div>
                      </div>
                    </form>
                    <ul className="list-group">
                      <li className="list-group-item">
                        <div className="d-flex justify-content-between">
                          <div>
                            <i className="fa fas fa-square"></i> - Não Enviado/Aguardando DETRAN
                          </div>
                          <div>{this.state.contractsNotRegistred ? <div className="font-weight-bold float-left text-danger">{this.state.contractsNotRegistred.qtd}</div> : "0"}</div>
                        </div>
                      </li>
                      <li className="list-group-item">
                        <div className="d-flex justify-content-between">
                          <div>
                            <i className="fa fas fa-square text-danger"></i> - Registro com erro
                          </div>
                          <div>{this.state.contractsRegistredError ? <div className="font-weight-bold float-left text-danger">{this.state.contractsRegistredError.qtd}</div> : "0"}</div>
                        </div>
                      </li>
                      <li className="list-group-item">
                        <div className="d-flex justify-content-between">
                          <div>
                            <i className="fa fas fa-square text-warning"></i> - Registrado sem imagem
                          </div>
                          <div>{this.state.contractsRegistredWithoutImage ? <div className="font-weight-bold float-left text-danger">{this.state.contractsRegistredWithoutImage.qtd}</div> : "0"}</div>
                        </div>
                      </li>
                      <li className="list-group-item">
                        <div className="d-flex justify-content-between">
                          <div>
                            <i className="fa fas fa-square text-success"></i> - Registrado
                          </div>
                          <div>{this.state.contractsRegistred ? <div className="font-weight-bold float-left text-danger">{this.state.contractsRegistred.qtd}</div> : "0"}</div>
                        </div>
                      </li>
                      <li className="list-group-item">
                        <div className="d-flex justify-content-between">
                          <div>
                            <i className="fa fas fa-square text-primary"></i> - Cancelado/Baixado
                          </div>
                          <div>{this.state.contractsCancel ? <div className="font-weight-bold float-left text-danger">{this.state.contractsCancel.qtd}</div> : "0"}</div>
                        </div>
                      </li>
                      <li className="list-group-item list-group-item-light font-weight-bold">
                        <div className="d-flex justify-content-between">
                          <div>TOTAL</div>
                          <div>
                            {(this.state.contractsNotRegistred ? this.state.contractsNotRegistred.qtd : 0) +
                              (this.state.contractsRegistredError ? this.state.contractsRegistredError.qtd : 0) +
                              (this.state.contractsRegistredWithoutImage ? this.state.contractsRegistredWithoutImage.qtd : 0) +
                              (this.state.contractsRegistred ? this.state.contractsRegistred.qtd : 0) +
                              (this.state.contractsCancel ? this.state.contractsCancel.qtd : 0)}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}
            {this.props.currentUser.funcionalidades.includes(4) && (
              <div className="col-md-4">
                <div className="hpanel stats">
                  <div className="panel-heading">
                    <div className="panel-tools"></div>
                    <p>Financeiras</p>
                  </div>
                  <div className="panel-body h-100">
                    <div className="row m-b-sm">
                      <div className="col-md-12">
                        <div className="stats-title float-left">
                          {" "}
                          <h3>{"FINANCEIRAS INATIVAS (> 5 DIAS)"}</h3>
                        </div>
                        <div className="float-rigth">
                          <Link className="btn btn-default btn-sm float-right" onClick={() => this.exportFinInvalidasToCSV()} title="Gerar Excel">
                            {" "}
                            <SvgIcon icon={fileExcelO} />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <ul className="list-group">
                      <li className="list-group-item list-group-item-light font-weight-bold">
                        <div className="d-flex justify-content-between">
                          <div>TOTAL</div>
                          <div>{this.props.listFinancialInvalid.length}</div>
                        </div>
                      </li>
                      {this.mountFinInvalid()}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <FinancialDashboardUfModal
          visible={this.state.ufsModalOpen}
          financeira={this.state.ufsModalFinanceira}
          data={this.state.ufsModalData}
          loading={this.state.ufsModalLoading}
          onClose={this.handleCloseUfsModal.bind(this)}
          exibirValores={this.state.exibirValores}
          getColumnHighlightClass={this.getColumnHighlightClass.bind(this)}
        />
      </div>
    );
  }

  mountFinInvalid() {
    if (!this.props.listFinancialInvalid) {
      return null;
    }
    let listFinHtml = [];
    let x = 0;
    while (x < 5 && this.props.listFinancialInvalid.length > x) {
      listFinHtml.push(
        <li className="list-group-item">
          <div className="d-flex justify-content-between">
            <div
              className="font-weight-bold float-left text-danger"
              id={x}
              onClick={() => {
                this.setState({ open: window.event.target.id });
              }}
            >
              {this.props.listFinancialInvalid[x].razaoSocial}
            </div>
          </div>
          <div
            id={x}
            className={
              document.getElementById(x) && document.getElementById(x).id == this.state.open
                ? "panel-collapse-dasboard-financeira"
                : "panel-collapse-dasboard-financeira panel-close-dasboard-financeira"
            }
          >
            <ul className="list-group">
              {document.getElementById(x) &&
                this.props.listFinancialInvalid[document.getElementById(x).id].financeiraFilha.map((item) => {
                  return (
                    <li className="list-group-item">
                      <div className="d-flex justify-content-between col-md-12">
                        <div className="col-md-8" style={{ margin: "0 -37px" }}>
                          {item.filha}
                        </div>
                        <div className="col-md-1">{item.uf}</div>
                        <div className="col-md-3">{MaskDate.TO_BR(item.ultimaCobranca)}</div>
                      </div>
                    </li>
                  );
                })}
            </ul>
          </div>
        </li>,
      );
      x++;
    }
    return listFinHtml;
  }
}

const mapDispatchToProps = (dispatch) => ({
  onListLoad: (payload) => dispatch({ type: FINANCIAL_DASHBOARD_LIST_LOAD, payload }),
  onContractsExpiredLoad: (payload) => dispatch({ type: FINANCIAL_DASHBOARD_CONTRACTS_EXPIRED_LOAD, payload }),
  onContractsExpired7Load: (payload) => dispatch({ type: FINANCIAL_DASHBOARD_CONTRACTS_EXPIRED_7_LOAD, payload }),
  onContractsExpired15Load: (payload) => dispatch({ type: FINANCIAL_DASHBOARD_CONTRACTS_EXPIRED_15_LOAD, payload }),
  onContractsExpired30Load: (payload) => dispatch({ type: FINANCIAL_DASHBOARD_CONTRACTS_EXPIRED_30_LOAD, payload }),
  onCompaniesLoad: (payload) => dispatch({ type: FINANCIAL_DASHBOARD_COMPANIES_LOAD, payload }),
  onUnload: (payload) => dispatch({ type: FINANCIAL_DASHBOARD_LIST_UNLOAD }),
  onUfSystemLoad: (payload) => dispatch({ type: UF_SYSTEM_LOAD, payload }),
  onNotRegistredLoad: (payload) => dispatch({ type: FINANCIAL_DASHBOARD_NOT_REGISTRED_LOAD, payload }),
  onRegistredErrorLoad: (payload) => dispatch({ type: FINANCIAL_DASHBOARD_REGISTRED_ERROR_LOAD, payload }),
  onRegistredWithoutImageLoad: (payload) =>
    dispatch({
      type: FINANCIAL_DASHBOARD_REGISTRED_WITHOUT_IMAGE_LOAD,
      payload,
    }),
  onContractsRegistredLoad: (payload) => dispatch({ type: FINANCIAL_DASHBOARD_REGISTRED_LOAD, payload }),
  onContractClearImageVisao: (payload) => dispatch({ type: FINANCIAL_DASHBOARD_CLEAR_IMAGENS_VISAO, payload }),
  onListLoadFinancialInvalid: (payload) => dispatch({ type: FINANCIAL_INVALID, payload }),
  onListLoadFilter: (payload) => dispatch({ type: FINANCIAL_LIST_FILTER, payload }),
});

const selector = formValueSelector("FinancialDashboardForm");
const mapStateToProps = (state) => ({
  ...state.financialDashboard,
  selectedUf: selector(state, "uf"),
  currentUser: state.common.currentUser,
});

const form = reduxForm({
  form: "FinancialDashboardForm",
  enableReinitialize: true,
});

export default connect(mapStateToProps, mapDispatchToProps)(form(FinancialDashboard));
